<template>
    <section style="display: flex; height: max-content; min-height: 100%;">
        <div class="left-side-bar" style="width: 270px;">
            <div class="logo-wrapper">
                <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-img">
            </div>
            <div class="side-menu-wrapper">
                <div class="side-menu-item" @click="openTab = 'overview'" :class="{ active: openTab === 'overview'}">Overview</div>
                <div class="side-menu-item" @click="openTab = 'unitmix'" :class="{ active: openTab === 'unitmix'}">Unit Mix</div>
                <div class="side-menu-item" @click="openTab = 'image'" :class="{ active: openTab === 'image'}">Image Gallery</div>
                <div class="side-menu-item" @click="openTab = 'availability'" :class="{ active: openTab === 'availability'}">Availability</div>
                <div class="side-menu-item" @click="openTab = 'developmentstats'" :class="{ active: openTab === 'developmentstats'}">Development Stats</div>
                <div class="side-menu-item" @click="openTab = 'permits'" :class="{ active: openTab === 'permits'}">Permit</div>
                <div class="side-menu-item" @click="openTab = 'notes'" :class="{ active: openTab === 'notes'}">Notes</div>
                <div class="side-menu-item" @click="openTab = 'history'" :class="{ active: openTab === 'history'}">Project History</div>
                <div v-if="project.is_admin" class="side-menu-item" @click="openTab = 'upload'" :class="{ active: openTab === 'upload'}">Upload</div>
            </div>
            <div class="side-menu-bottom">
                <div class="side-menu-bottom-item">New Features</div>
                <div class="side-menu-bottom-item" @click="logout()">LOG OUT</div>
                <div class="side-menu-bottom-item"><a href="/presale-database#contact" style="color: #fff;">CONTACT</a></div>
            </div>
        </div>
        <div class="type-container" style="height: max-content;">
            <div class="fl-wrap single-project-detail">
                <div class="row print-none type-title">
                    <h1>{{project.status}}</h1>
                    <div class="type-icons print-none">
                        <!-- {{project.developer}} -->
                        <img class="function_icons" src="/images/assets/favorites_icon.png">
                        <img class="function_icons" src="/images/assets/export_icon.png">
                        <img class="function_icons" src="/images/assets/googlemap_icon.png">
                    </div>
                </div>
                <div class="row print-none" v-if="project.is_admin">
                    <div class="text-left col-md-1 mt-auto"><a class="edit-button" v-if="project.is_admin" :href="'https://www.realpropertydata.ca/backend/node/'+project.nid+'/edit'">Edit</a></div>
                    <div class="text-left col-md-1 mt-auto"><a class="view-button" v-if="project.is_admin" :href="'https://www.realpropertydata.ca/backend/node/'+project.nid">View</a></div>
                    <div class="text-left col-md-2 mt-auto"><a v-if="project.is_admin" :href="project_link+'&tab='+$route.query.fid">Presale Page</a></div>
                    <!-- <div class="col-md-2 text-right mt-auto">
                        <a :href="project.web_link[0]" target="_blank" class="type-ad-header" style="color: #2C3E5A"><font-awesome-icon style="color: #2C3E5A;" :icon="['fas', 'share-square']" /> Project Website</a>
                    </div> -->
                </div>
                <div class="row mt-10" style="max-width: 1280px; border-bottom: 3px solid #BBB; padding-bottom: 15px;">
                    <div class="col-xs-6 text-left">
                        <a :href="project.web_link[0]" target="_blank" ><h2 style="font-size: 2.2rem;"><strong>{{project.project_name}}</strong></h2></a>
                    </div>
                    <div class="col-xs-6 text-right">
                        <div class="row">
                            <div class="col-md-12">
                                {{project.address}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-row">
                    <b-tabs
                        active-nav-item-class="type-nav-active"
                        active-tab-class="type-content-active"
                        nav-class="type-nav-general print-none"
                        >
                        <b-tab title="Overview" :active="openTab === 'overview'">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-5">
                                        <!-- <div class="row px-2 pt-4 text-left row-green">
                                        </div> -->
                                        <div class="row px-2 pt-4 text-left">
                                            <div class="col-xs-6">
                                                <strong>Project Type</strong>
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                <strong>{{project.new_p_type}}</strong>
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left">
                                            <div class="col-xs-6">
                                                Storey
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.new_p_storey}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left">
                                            <div class="col-xs-6">
                                                Unit Type
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.utc_specified.gut}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left">
                                            <div class="col-xs-6">
                                                Construction Status
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.construction_status}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                            <div class="col-xs-6">
                                                Deposit
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.deposit}}%
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left" v-else>
                                            <div class="col-xs-6">
                                                Site Area
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.site_area}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                            <div class="col-xs-6">
                                                Sales Start Date
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.sales_start_date}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left" v-else>
                                            <div class="col-xs-6">
                                                Existing Use
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.existing_use}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left" v-if="project.status == 'Sold Out'">
                                            <div class="col-xs-6">
                                                Sold Out Date
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.sold_out_date}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left">
                                            <div class="col-xs-6">
                                                Neighbourhood
                                            </div>
                                            <div class="col-xs-6 overview-val">
                                                {{project.neighbor}}
                                            </div>
                                        </div>
                                        <div class="row px-2 pt-4 text-left hidden-md hidden-sm hidden-xs print-none">
                                            <span style="cursor: pointer;" v-b-modal="'site-plan-files'" class="btn btn-primary-reverse col-xs-5 ml-2">Site Plan</span>
                                            <span class="col-xs-1"></span>
                                            <span style="cursor: pointer;" v-b-modal="'consultant'" class="btn btn-primary-reverse col-xs-5">Consultants</span>
                                        </div>
                                    </div>
                                    <div class="col-md-7 pt-1 mobile-mt-20 print-none">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div id='map' style="height: 430px"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row px-2 pt-4 text-left hidden-lg print-none">
                                    <span style="cursor: pointer;" v-b-modal="'site-plan-files'" class="btn btn-primary-reverse col-xs-5 ml-2">Site Plan</span>
                                    <span class="col-xs-1"></span>
                                    <span style="cursor: pointer;" v-b-modal="'consultant'" class="btn btn-primary-reverse col-xs-5">Consultants</span>
                                </div>
                                <div class="row" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                    <div class="col-xs-12 text-left mt-20">
                                        <h3>Project Total</h3>
                                    </div>
                                </div>

                                <div class="row" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Total Units</div>
                                            <div><strong>{{ project.unit_component.total }}</strong></div>
                                        </div>
                                    </div>
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Rlsd Units</div>
                                            <div><strong>{{ project.unit_component.rlsd_units }}</strong></div>
                                        </div>
                                    </div>
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Sold Units</div>
                                            <div><strong>{{ project.unit_component.sold_total }}</strong></div>
                                        </div>
                                    </div>
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Avail Units</div>
                                            <div><strong>{{ project.unit_component.available ? project.unit_component.available : '0' }}</strong></div>
                                        </div>
                                    </div>
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>DOM</div>
                                            <div><strong>{{ project.unit_component.dom }}</strong></div>
                                        </div>
                                    </div>
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Avg SF</div>
                                            <div><strong>{{ numberWithCommas(project.unit_component.avg_size) }}</strong></div>
                                        </div>
                                    </div>
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Avg Price</div>
                                            <div><strong>{{ project.unit_component.avg_price > 0 ? '$' + numberWithCommas(project.unit_component.avg_price) : '-' }}</strong></div>
                                        </div>
                                    </div>
                                    <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Avg $PSF</div>
                                            <div><strong>{{ project.unit_component.avg_psf ? '$' + numberWithCommas(project.unit_component.avg_psf) : '-' }}</strong></div>
                                        </div>
                                    </div>
                                    <!-- <div class="square-wrapper">
                                        <div class="square-blue">
                                            <div>Updated</div>
                                            <div><strong>{{ project.unit_component.updated }}</strong></div>
                                        </div>
                                    </div> -->
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 text-left mt-20">
                                        <h3>Unit Breakdown</h3>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <template v-if="project.unit_component.bed && project.unit_component.bed.length !== 0">
                                            <table class="table mt-3">
                                                <thead class="fp-header">
                                                    <!-- <th>Plan Name</th> -->
                                                    <th>Beds</th>
                                                    <th>FP Specs</th>
                                                    <th>Baths</th>
                                                    <th># Units</th>
                                                    <th>Parking</th>
                                                    <th>Stalls</th>
                                                    <th>Min SF</th>
                                                    <th>Max SF</th>
                                                    <th>Avg SF</th>
                                                    <th>Min Price</th>
                                                    <th>Max Price</th>
                                                    <th>Avg Price</th>
                                                    <th>Avg $PSF</th>
                                                </thead>
                                                <tbody class="fp-body">
                                                    <tr style="cursor: pointer;" v-b-modal="'mls-unit-'+unit_key" v-for="(unit_t, unit_key) in mlsTotalSort" v-bind:key="unit_key">
                                                        <!-- <td v-if="typeof unit_t.plan_name != 'undefined'">{{unit_t.plan_name.join(', ')}}</td> -->
                                                        <!-- <td v-else></td> -->
                                                        <td class="bed-column" style="color: #FC5868; text-decoration: underline;" v-if="unit_t.bed == '-'">{{unit_t.bed}}</td>
                                                        <td class="bed-column" style="color: #FC5868; text-decoration: underline;" v-else-if="unit_t.bed == '0'">0</td>
                                                        <td class="bed-column" style="color: #FC5868; text-decoration: underline;" v-else>{{unit_t.bed ? unit_t.bed.replace('jr', 'Junior').replace('s', 'Studio')+'-bed' : '0'}}</td>
                                                        <td>{{unit_t.fp_specs}}</td>
                                                        <td>{{unit_t.bath}}</td>
                                                        <td>{{unit_t.num}}</td>
                                                        <td>{{unit_t.parking}}</td>
                                                        <td>{{unit_t.stall ? unit_t.stall.final : ''}}</td>
                                                        <td>{{unit_t.minSize | numFormat}}</td>
                                                        <td>{{unit_t.maxSize | numFormat}}</td>
                                                        <td>{{unit_t.total_size*1.0 / unit_t.num | numFormat}}</td>
                                                        <td>{{unit_t.minPrice ? '$'+numberWithCommas(unit_t.minPrice) : '-'}}</td>
                                                        <td>{{unit_t.maxPrice ? '$'+numberWithCommas(unit_t.maxPrice) : '-'}}</td>
                                                        <td>{{unit_t.avgPrice ? '$'+numberWithCommas(unit_t.avgPrice) : '-'}}</td>
                                                        <td>{{(unit_t.avgPrice && unit_t.total_size && unit_t) ? '$'+numberWithCommas((unit_t.avgPrice/(unit_t.total_size/unit_t.num)).toFixed(0)) : '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <b-modal v-for="(unit_t, unit_key) in mlsTotalSort" v-bind:key="unit_key" :id="'mls-unit-'+unit_key" hide-footer>
                                                <template #modal-header="{ close }">
                                                    <!-- Emulate built in modal header close button action -->
                                                    <h5>FLOOR PLAN BREAKDOWN</h5>
                                                    <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal">
                                                    <button type="button" aria-label="Close" class="close modal-close"  @click="close()">×</button>
                                                </template>
                                                <div class="row my-30">
                                                    <div class="col-xs-6 text-left">
                                                        <a :href="project.web_link[0]" target="_blank" ><h2><strong>{{project.project_name}}</strong></h2></a>
                                                    </div>
                                                    <div class="col-sm-6 text-right">
                                                        <div class="modal-address">{{project.address}}</div>
                                                    </div>
                                                </div>
                                                <table class="table text-left table-borderless plan-table">
                                                    <thead>
                                                        <th>BED</th>
                                                        <th>BATH</th>
                                                        <th>FP SPECS</th>
                                                        <th>SF</th>
                                                        <th>PLAN NAME</th>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="bed-column">
                                                                {{unit_t.bed ? unit_t.bed : '0'}}-bed
                                                            </td>
                                                            <td>
                                                                {{unit_t.bath ? unit_t.bath : '0'}}-bath
                                                            </td>
                                                            <td>{{unit_t.fp_specs}}</td>
                                                            <td>
                                                                {{unit_t.minSize | numFormat}} - {{unit_t.maxSize | numFormat}} SF
                                                            </td>
                                                            <td>
                                                                <span v-if="(typeof unit_t.plan_name != 'undefined')">{{unit_t.plan_name.join(', ')}}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div class="col-xs-6 d-block text-center" v-for="(file, file_key) in unit_t.floor_plan" :key="file_key">
                                                    <div class="row fp-img">
                                                        <a target="_blank" :href="file.link">
                                                            <img class='floorplan-pdf' :src="file.preview">
                                                        </a>
                                                    </div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4"><b>Unit #</b></div>
                                                        <div class="col-xs-4"><b>Status</b></div>
                                                        <div class="col-xs-4" v-if="file.status == 'Active'"><b>List Price</b></div>
                                                        <div class="col-xs-4" v-else><b>Sold Price</b></div>
                                                    </div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4">{{file.unit_num}}</div>
                                                        <div class="col-xs-4">{{file.status}}</div>
                                                        <div v-if="file.status == 'Active'" class="col-xs-4">{{file.list_price ? '$'+numberWithCommas(file.list_price) : '$0'}}</div>
                                                        <div v-else class="col-xs-4">{{file.sold_price ? '$'+numberWithCommas(file.sold_price) : '$0'}}</div>
                                                    </div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4"><b>Beds</b></div>
                                                        <div class="col-xs-4"><b>Baths</b></div>
                                                        <div class="col-xs-4"><b>Size</b></div>
                                                    </div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4">{{unit_t.bed ? unit_t.bed : '0'}}</div>
                                                        <div class="col-xs-4">{{unit_t.bath ? unit_t.bath : '0'}}</div>
                                                        <div class="col-xs-4">{{file.unit_size}}</div>
                                                    </div>
                                                </div>
                                            </b-modal>
                                        </template>
                                    </div>
                                </div>
                                <div class="row print-only-flex">
                                    <div class="col-md-12">
                                        <h2 class="table-header-text text-left">Permits and Bylaws</h2>
                                        <table class="table text-left">
                                            <thead class="table-borderless fp-header" style="background: #12283FE5;">
                                                <th>TYPE</th>
                                                <th><div style="margin-left: 30px;">STATUS</div></th>
                                                <th>SUBMISSION DATE</th>
                                                <th>STATUS DATE</th>
                                                <th># Month</th>
                                            </thead>
                                            <tbody>
                                                <tr v-if="project.sd_sub_date || project.sd_app_date">
                                                    <td><b>Subdivision Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.sd_status)">⬤ {{project.sd_status}}</span></td>
                                                    <td>{{project.sd_sub_date ? project.sd_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.ss_sub_date || project.ss_app_date">
                                                    <td><b>Site Servicing Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.ss_status)">⬤ {{project.ss_status}}</span></td>
                                                    <td>{{project.ss_sub_date ? project.ss_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td><b>Rezoning</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.rz_status)">⬤ {{project.rz_status}}</span></td>
                                                    <td>{{project.rz_sub_date ? project.rz_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.rz_fsr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First and Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_fsr_diff.app ? project.rz_fsr_diff.app : '-'}}</td>
                                                    <td>{{project.rz_fsr_diff.month ? project.rz_fsr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_fr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_fr_diff.app ? project.rz_fr_diff.app : '-'}}</td>
                                                    <td>{{project.rz_fr_diff.month ? project.rz_fr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_sr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_sr_diff.app ? project.rz_sr_diff.app : '-'}}</td>
                                                    <td>{{project.rz_sr_diff.month ? project.rz_sr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_app_diff.app ? project.rz_app_diff.app : '-'}}</td>
                                                    <td>{{project.rz_app_diff.month ? project.rz_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_adopt_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Adoption</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_adopt_diff.app ? project.rz_adopt_diff.app : '-'}}</td>
                                                    <td>{{project.rz_adopt_diff.month ? project.rz_adopt_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.oa_sub_date || project.oa_app_date">
                                                    <td><b>OCP Amendment Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.oa_status)">⬤ {{project.oa_status}}</span></td>
                                                    <td>{{project.oa_sub_date ? project.oa_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.ocp_fsr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First and Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_fsr_diff.app ? project.ocp_fsr_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_fsr_diff.month ? project.ocp_fsr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_fr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_fr_diff.app ? project.ocp_fr_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_fr_diff.month ? project.ocp_fr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_sr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_sr_diff.app ? project.ocp_sr_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_sr_diff.month ? project.ocp_sr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_app_diff.app ? project.ocp_app_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_app_diff.month ? project.ocp_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_adopt_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Adoption</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_adopt_diff.app ? project.ocp_adopt_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_adopt_diff.month ? project.ocp_adopt_diff.month : '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Development Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.dp_status)">⬤ {{project.dp_status}}</span></td>
                                                    <td>{{project.dp_sub_date ? project.dp_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.dp_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dp_app_diff.app ? project.dp_app_diff.app : '-'}}</td>
                                                    <td>{{project.dp_app_diff.month ? project.dp_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.dp_issuance_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Issuance</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dp_issuance_diff.app ? project.dp_issuance_diff.app : '-'}}</td>
                                                    <td>{{project.dp_issuance_diff.month ? project.dp_issuance_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.dvp_sub_date || project.dvp_app_date">
                                                    <td><b>Development Variance Application</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.dvp_status)">⬤ {{project.dvp_status}}</span></td>
                                                    <td>{{project.dvp_sub_date ? project.dvp_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.dvp_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dvp_app_diff.app ? project.dvp_app_diff.app : '-'}}</td>
                                                    <td>{{project.dvp_app_diff.month ? project.dvp_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.dvp_issuance_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Issuance</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dvp_issuance_diff.app ? project.dvp_issuance_diff.app : '-'}}</td>
                                                    <td>{{project.dvp_issuance_diff.month ? project.dvp_issuance_diff.month : '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Building Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.bp_status)">⬤ {{project.bp_status}}</span></td>
                                                    <td>{{project.bp_sub_date ? project.bp_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.demolition_sub_date || project.demolition_app_date">
                                                    <td><b>Demolition Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.demolition_status)">⬤ {{project.demolition_status}}</span></td>
                                                    <td>{{project.demolition_sub_date ? project.demolition_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="row mt-5  print-only-flex">
                                    <div class="col-md-12">
                                        <h2 style="float: left;" class="table-header-text text-left">PLANNING PROCESS</h2><span class="hidden-xs hidden-sm hidden-md btn btn-primary-reverse print-none" style="float: right; margin-top: 20px;" v-b-modal="'planning-docs'">Planning Docs</span>
                                        <table class="table">
                                            <thead class="fp-header">
                                                <th>Date</th>
                                                <th>Application Type</th>
                                                <th>Application Stage</th>
                                                <th>Outcome</th>
                                                <th>CBA Status</th>
                                            </thead>
                                            <tbody class="fp-body fp-border">
                                                <tr class="planning-table-cell" v-for="(val, key) in permitSort" :key="key">
                                                    <td class="text-center">
                                                        <a v-if="val.file" :href="val.file" target="_blank">{{val.time}}</a>
                                                        <div v-else>{{val.time}}</div>
                                                    </td>
                                                    <td class="text-center">{{val.col_1}}</td>
                                                    <td class="text-center">{{val.col_2}}</td>
                                                    <td class="text-center" v-html="(val.col_3 ? val.col_3 : '') + (val.col_4 ? '<br>'+val.col_4: '') + (val.col_5 ? '<br>'+val.col_5: '') + (val.col_6 ? '<br>'+val.col_6: '')"></td>
                                                    <td>
                                                        <div v-if="val.rz">REZ: {{val.rz}}</div>
                                                        <div v-if="val.dp">DP: {{val.dp}}</div>
                                                        <div v-if="val.dvp">DVP: {{val.dvp}}</div>
                                                        <div v-if="val.sub">Sub: {{val.sub}}</div>
                                                        <div v-if="val.srv">Serv: {{val.srv}}</div>
                                                        <div v-if="val.demo">Demo: {{val.demo}}</div>
                                                        <div v-if="val.ocp">OCP: {{val.ocp}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <span class="btn btn-primary-reverse hidden-lg" style="float: right; margin-top: 20px;" v-b-modal="'planning-docs'">Planning Docs</span>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="Image Gallery" :active="openTab === 'image'">
                            <div class="row mt-20 print-none type-image">
                                <div class="col-xs-12">
                                    <h2 style="text-decoration: none;">MEDIA GALLERY</h2>
                                    <b-tabs
                                        active-nav-item-class="type-nav-active"
                                        active-tab-class="type-content-active"
                                        nav-class="type-nav-general"
                                        >
                                        <b-tab title="Project" active>
                                            <LightGallery
                                                :images="picListProject"
                                                :index="projectImgindex"
                                                :disable-scroll="true"
                                                @close="projectImgindex = null"
                                                />
                                            <div class="row">
                                                <div class="col-lg-3 col-xs-6 pic-media-wrapper" v-for="(thumb, thumbIndex) in picListProject"
                                                    :key="thumbIndex"
                                                    @click="projectImgindex = thumbIndex">
                                                    <img :src="thumb.thumb" class="pic-media">
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Interior" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                            <LightGallery
                                                :images="picListInterior"
                                                :index="interiorImgindex"
                                                :disable-scroll="true"
                                                @close="interiorImgindex = null"
                                                />
                                            <div class="row">
                                                <div class="col-lg-3 col-xs-6 pic-media-wrapper" v-for="(thumb, thumbIndex) in picListInterior"
                                                    :key="thumbIndex"
                                                    @click="interiorImgindex = thumbIndex">
                                                    <img :src="thumb.thumb" class="pic-media">
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Amenity" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                            <LightGallery
                                                :images="picListAmenity"
                                                :index="amenityImgindex"
                                                :disable-scroll="true"
                                                @close="amenityImgindex = null"
                                                />
                                            <div class="row">
                                                <div class="col-lg-3 col-xs-6 pic-media-wrapper" v-for="(thumb, thumbIndex) in picListAmenity"
                                                    :key="thumbIndex"
                                                    @click="amenityImgindex = thumbIndex">
                                                    <img :src="thumb.thumb" class="pic-media">
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Presentation Centre" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                            <LightGallery
                                                :images="picListPresentation"
                                                :index="presentationImgindex"
                                                :disable-scroll="true"
                                                @close="presentationImgindex = null"
                                                />
                                            <div class="row">
                                                <div class="col-lg-3 col-xs-6 pic-media-wrapper" v-for="(thumb, thumbIndex) in picListPresentation"
                                                    :key="thumbIndex"
                                                    @click="presentationImgindex = thumbIndex">
                                                    <img :src="thumb.thumb" class="pic-media">
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Site Photos" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                            <LightGallery
                                                :images="picListSite"
                                                :index="siteImgindex"
                                                :disable-scroll="true"
                                                @close="siteImgindex = null"
                                                />
                                            <div class="row">
                                                <div class="col-lg-3 col-xs-6 pic-media-wrapper" v-for="(thumb, thumbIndex) in picListSite"
                                                    :key="thumbIndex"
                                                    @click="siteImgindex = thumbIndex">
                                                    <img :src="thumb.thumb" class="pic-media">
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab title="Construction" v-if="project.status != 'Selling Soon' && project.status != 'In Planning'">
                                            <LightGallery
                                                :images="picListConstruction"
                                                :index="constructionImgindex"
                                                :disable-scroll="true"
                                                @close="constructionImgindex = null"
                                                />
                                            <div class="row">
                                                <div class="col-lg-3 col-xs-6 pic-media-wrapper" v-for="(thumb, thumbIndex) in picListConstruction"
                                                    :key="thumbIndex"
                                                    @click="constructionImgindex = thumbIndex">
                                                    <img :src="thumb.thumb" class="pic-media">
                                                </div>
                                            </div>
                                        </b-tab>
                                    </b-tabs>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab  title="Unit Mix" :active="openTab === 'unitmix'" v-if="((project.mls_last_date_active.length !== 0 && typeof project.mls_last_date_active != 'undefined') || (project.mls_last_date_sold.length !== 0 && typeof project.mls_last_date_sold != 'undefined') || (project.mls_last_date_other.length !== 0 && typeof project.mls_last_date_other != 'undefined')) && project.is_admin">
                            <div class="row py-3">
                                <div class="col-md-12">
                                    <template v-if="(project.mls_last_date_active.length !== 0 && typeof project.mls_last_date_active != 'undefined')">
                                        <h1 class="text-left">Active Listings</h1>
                                        <table class="table mt-3">
                                            <thead class="fp-header">
                                                <th @click="activeSort('mls_address')" style="cursor: pointer;">Unit #</th>
                                                <th>PID</th>
                                                <th @click="activeSort('mls_plan_name')" style="cursor: pointer;">Plan Name</th>
                                                <th>List date</th>
                                                <th>Price date</th>
                                                <th @click="activeSort('mls_list_price')" style="cursor: pointer;">List Price</th>
                                                <th @click="activeSort('mls_beds')" style="cursor: pointer;">Beds</th>
                                                <th @click="activeSort('mls_baths')" style="cursor: pointer;">Baths</th>
                                                <th @click="activeSort('mls_unit_size')" style="cursor: pointer;">Unit Size</th>
                                                <th @click="activeSort('mls_psf')" style="cursor: pointer;">$PSF</th>
                                                <th @click="activeSort('mls_dom')" style="cursor: pointer;">DOM</th>
                                                <th>FP Specs</th>
                                                <th>Parking</th>
                                                <th>Stalls</th>
                                                <th>Status</th>
                                                <th>View</th>
                                                <th>Delete</th>
                                            </thead>
                                            <tbody class="fp-body">
                                                <tr v-for="(d, k) in mlsActiveSort" style="cursor:pointer;" :key="k">
                                                    <td v-if="d.mls_floor_plan_feature.fid" v-b-modal="'mls-fp-'+d.mls_floor_plan_feature.fid" class="mls-floorplan">{{d.mls_address}}</td>
                                                    <td v-else v-b-modal="'mls-active-'+d.cid">{{d.mls_address}}</td>
                                                    <td>{{d.mls_pid}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{d.mls_plan_name}}</td>
                                                    <td>{{d.mls_list_date}}</td>
                                                    <td>{{d.mls_price_date}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">${{d.mls_list_price | numFormat}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{(d.mls_beds > 0 || d.mls_beds === '0' || d.mls_beds == 's' || d.mls_beds == 'jr' ) ? d.mls_beds : '-'}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{(d.mls_baths > 0 || d.mls_baths === '0') ? d.mls_baths : '-'}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{(d.mls_unit_size > 0 || d.mls_unit_size === '0') ? d.mls_unit_size : '-'}}</td>
                                                    <td v-if="d.mls_psf > 0" v-b-modal="'mls-active-'+d.cid">${{d.mls_psf | numFormat}}</td>
                                                    <td v-else v-b-modal="'mls-active-'+d.cid">-</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{d.mls_dom}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{d.fp_specs}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{d.stalls}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{(d.mls_parking > 0 || d.mls_parking === '0') ? d.mls_parking : '-'}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{d.mls_status}}</td>
                                                    <td v-b-modal="'mls-active-'+d.cid">{{d.orientation == "None" ? '' : d.orientation}}</td>
                                                    <td @click="deleteMLS(d.cid)" style="cursor: pointer;">Delete</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <b-modal v-for="(d, k) in project.mls_last_date_active" :id="'mls-fp-'+d.mls_floor_plan_feature.fid" hide-footer :key="k">
                                            <div v-if="d.mls_floor_plan_feature.fid" class="col-md-4 d-block text-center">
                                                <a target="_blank" :href="d.mls_floor_plan_feature.link"><img class='floorplan-pdf' :src="d.mls_floor_plan_feature.preview"></a>
                                            </div>
                                        </b-modal>
                                        <b-modal v-for="(v_o, k_o) in project.mls_data" :id="'mls-active-'+k_o" hide-footer :key="k_o">
                                            <div class="row">
                                                <div class="col-md-4 text-left h5" style="cursor: pointer;">
                                                    Unit: <span v-if="v_o[v_o.length-1].mls_floor_plan_feature.fid" v-b-modal="'mls-fp-'+v_o[v_o.length-1].mls_floor_plan_feature.fid" class="mls-floorplan">{{v_o[v_o.length-1].mls_address}}</span>
                                                    <span v-else>{{v_o[v_o.length-1].mls_address}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Plan Name: <span>{{v_o[v_o.length-1].mls_plan_name}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Beds: <span>{{v_o[v_o.length-1].mls_beds}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    Baths: <span>{{v_o[v_o.length-1].mls_baths}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Unit Size: <span>{{v_o[v_o.length-1].mls_unit_size}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    View: <span>{{v_o[v_o.length-1].orientation == 'None' ? '' : v_o[v_o.length-1].orientation}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    Parking: <span>{{v_o[v_o.length-1].stalls}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Stalls: <span>{{v_o[v_o.length-1].mls_parking}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Locker: <span>{{v_o[v_o.length-1].mls_locker}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    GST included: <span>{{v_o[v_o.length-1].mls_get_included}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    PID: <span>{{v_o[v_o.length-1].mls_pid}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Levels: <span>{{v_o[v_o.length-1].levels}}</span>
                                                </div>
                                            </div>
                                            <table class="table mt-3">
                                                <thead class="fp-header">
                                                    <th>List date</th>
                                                    <th>List Price</th>
                                                    <th>Price Date</th>
                                                    <th>$PSF</th>
                                                    <th>DOM</th>
                                                    <th>SP Sqft</th>
                                                    <th>Sold Date</th>
                                                    <th>Status</th>
                                                    <th>Collection Type</th>
                                                    <th>FP Specs</th>
                                                    <th>Approval</th>
                                                    <th>Edit</th>
                                                    <th>Delete</th>
                                                </thead>
                                                <tbody class="fp-body">
                                                    <tr v-for="(v_i, k_i) in v_o" style="cursor: pointer;" :key="k_i">
                                                        <td>{{v_i.mls_list_date}}</td>
                                                        <td>${{v_i.mls_list_price | numFormat}}</td>
                                                        <td>{{v_i.mls_price_date}}</td>
                                                        <td v-if="v_i.mls_psf > 0">${{v_i.mls_psf | numFormat}}</td>
                                                        <td v-else>-</td>
                                                        <td>{{v_i.mls_dom}}</td>
                                                        <td v-if="v_i.mls_sp_sqft > 0">${{v_i.mls_sp_sqft | numFormat}}</td><td v-else>-</td>
                                                        <td>{{v_i.mls_sold_date}}</td>
                                                        <td>{{v_i.mls_status}}</td>
                                                        <td>{{v_i.collection_type}}</td>
                                                        <td>{{v_i.fp_specs}}</td>
                                                        <td v-if="v_i.mls_need_approval == 1" @click="approveMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">Approve</td>
                                                        <td v-else @click="unApproveMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">UnApprove</td>
                                                        <td @click.right="editMLSEntryNew(v_i.cid, v_i.entry)" @click="editMLSEntry(v_i.cid, v_i.entry)" style="cursor: pointer;">Edit</td>
                                                        <td @click="deleteMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">Delete</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-modal>
                                    </template>
                                    <template v-if="(project.mls_last_date_sold !== 0 && typeof project.mls_last_date_sold != 'undefined')">
                                        <h1 class="text-left">Sold Listings</h1>
                                        <table class="table mt-3">
                                            <thead class="fp-header">
                                                <th @click="soldSort('mls_address')" style="cursor: pointer;">Unit #</th>
                                                <th>PID</th>
                                                <th @click="soldSort('mls_plan_name')" style="cursor: pointer;">Plan Name</th>
                                                <th>List date</th>
                                                <th>Price date</th>
                                                <th @click="soldSort('mls_list_price')" style="cursor: pointer;">List Price</th>
                                                <th @click="soldSort('mls_beds')" style="cursor: pointer;">Beds</th>
                                                <th @click="soldSort('mls_baths')" style="cursor: pointer;">Baths</th>
                                                <th @click="soldSort('mls_unit_size')" style="cursor: pointer;">Unit Size</th>
                                                <th @click="soldSort('mls_sold_price')" style="cursor: pointer;">Sold Price</th>
                                                <th @click="soldSort('mls_sp_sqft')" style="cursor: pointer;">SP Sqft</th>
                                                <th>FP Specs</th>
                                                <th>Parking</th>
                                                <th>Stalls</th>
                                                <th>Sold Date</th>
                                                <th @click="activeSort('mls_dom')" style="cursor: pointer;">DOM</th>
                                                <th>Status</th>
                                                <th>View</th>
                                                <th>Delete</th>
                                            </thead>
                                            <tbody class="fp-body">
                                                <tr v-for="(d, k) in mlsSoldSort" style="cursor:pointer;" :key="k">
                                                    <td v-if="d.mls_floor_plan_feature.fid" v-b-modal="'mls-fp-'+d.mls_floor_plan_feature.fid" class="mls-floorplan">{{d.mls_address}}</td>
                                                    <td v-else v-b-modal="'mls-active-'+d.cid">{{d.mls_address}}</td>
                                                    <td>{{d.mls_pid}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{d.mls_plan_name}}</td>
                                                    <td>{{d.mls_list_date}}</td>
                                                    <td>{{d.mls_price_date}}</td>
                                                    <td v-if="d.mls_list_price > 0" v-b-modal="'mls-sold-'+d.cid" >${{d.mls_list_price | numFormat}}</td>
                                                    <td v-else>-</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{(d.mls_beds > 0 || d.mls_beds === '0' || d.mls_beds == 's' || d.mls_beds == 'jr' ) ? d.mls_beds : '-'}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{(d.mls_baths > 0 || d.mls_baths === '0') ? d.mls_baths : '-'}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{(d.mls_unit_size > 0 || d.mls_unit_size === '0') ? d.mls_unit_size : '-'}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid"  v-if="d.mls_sold_price != '-'">${{d.mls_sold_price | numFormat}}</td><td v-else>-</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid"  v-if="d.mls_sp_sqft > 0">${{d.mls_sp_sqft | numFormat}}</td><td v-else>-</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid">{{d.fp_specs}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid">{{d.stalls}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid">{{d.mls_parking}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{d.mls_sold_date}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{d.mls_dom}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{d.mls_status}}</td>
                                                    <td v-b-modal="'mls-sold-'+d.cid" >{{d.orientation == "None" ? '' : d.orientation}}</td>
                                                    <td @click="deleteMLS(d.cid)" style="cursor: pointer;">Delete</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <b-modal v-for="(d, k) in project.mls_last_date_sold" :id="'mls-fp-'+d.mls_floor_plan_feature.fid" hide-footer :key="k">
                                            <div v-if="d.mls_floor_plan_feature.fid" class="col-md-4 d-block text-center">
                                                <a target="_blank" :href="d.mls_floor_plan_feature.link"><img class='floorplan-pdf' :src="d.mls_floor_plan_feature.preview"></a>
                                            </div>
                                        </b-modal>
                                        <b-modal v-for="(v_o, k_o) in project.mls_data" :id="'mls-sold-'+k_o" hide-footer :key="k_o">
                                            <div class="row">
                                                <div class="col-md-4 text-left h5" style="cursor: pointer;">
                                                    Unit: <span v-if="v_o[v_o.length-1].mls_floor_plan_feature.fid" v-b-modal="'mls-fp-'+v_o[v_o.length-1].mls_floor_plan_feature.fid" class="mls-floorplan">{{v_o[v_o.length-1].mls_address}}</span>
                                                    <span v-else>{{v_o[v_o.length-1].mls_address}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Plan Name: <span>{{v_o[v_o.length-1].mls_plan_name}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Beds: <span>{{v_o[v_o.length-1].mls_beds}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    Baths: <span>{{v_o[v_o.length-1].mls_baths}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Unit Size: <span>{{v_o[v_o.length-1].mls_unit_size}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    View: <span>{{v_o[v_o.length-1].orientation == "None" ? '' : v_o[v_o.length-1].orientation}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    Parking: <span>{{v_o[v_o.length-1].stalls}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Stalls: <span>{{v_o[v_o.length-1].mls_parking}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Locker: <span>{{v_o[v_o.length-1].mls_locker}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    GST included: <span>{{v_o[v_o.length-1].mls_get_included}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    PID: <span>{{v_o[v_o.length-1].mls_pid}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Levels: <span>{{v_o[v_o.length-1].levels}}</span>
                                                </div>
                                            </div>
                                            <table class="table mt-3">
                                                <thead class="fp-header">
                                                    <th>List date</th>
                                                    <th>List Price</th>
                                                    <th>Price Date</th>
                                                    <th>Sold Price</th>
                                                    <th>SP Sqft</th>
                                                    <th>Sold Date</th>
                                                    <th>DOM</th>
                                                    <th>Status</th>
                                                    <th>Collection Type</th>
                                                    <th>FP Specs</th>
                                                    <th>Approval</th>
                                                    <th>Edit</th>
                                                    <th>Delete</th>
                                                </thead>
                                                <tbody class="fp-body">
                                                    <tr v-for="(v_i, k_i) in v_o" :key="k_i">
                                                        <td>{{v_i.mls_list_date}}</td>
                                                        <td v-if="v_i.mls_list_price > 0">${{v_i.mls_list_price | numFormat}}</td>
                                                        <td v-else>-</td>
                                                        <td>{{v_i.mls_price_date}}</td>
                                                        <td v-if="v_i.mls_sold_price != '-'">${{v_i.mls_sold_price | numFormat}}</td><td v-else>-</td>
                                                        <td v-if="v_i.mls_sp_sqft > 0">${{v_i.mls_sp_sqft | numFormat}}</td><td v-else>-</td>
                                                        <td>{{v_i.mls_sold_date}}</td>
                                                        <td>{{v_i.mls_dom}}</td>
                                                        <td>{{v_i.mls_status}}</td>
                                                        <td>{{v_i.collection_type}}</td>
                                                        <td>{{v_i.fp_specs}}</td>
                                                        <td v-if="v_i.mls_need_approval == 1" @click="approveMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">Approve</td>
                                                        <td v-else @click="unApproveMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">UnApprove</td>
                                                        <td @click.right="editMLSEntryNew(v_i.cid, v_i.entry)" @click="editMLSEntry(v_i.cid, v_i.entry)" style="cursor: pointer;">Edit</td>
                                                        <td @click="deleteMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">Delete</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-modal>
                                    </template>
                                    <template v-if="(project.mls_last_date_other !== 0 && typeof project.mls_last_date_other != 'undefined')">
                                        <h1 class="text-left">Unreleased Listing</h1>
                                        <table class="table mt-3">
                                            <thead class="fp-header">
                                                <th @click="otherSort('mls_address')" style="cursor: pointer;">Unit #</th>
                                                <th>PID</th>
                                                <th @click="otherSort('mls_plan_name')" style="cursor: pointer;">Plan Name</th>
                                                <th>List date</th>
                                                <th>Price date</th>
                                                <th @click="otherSort('mls_list_price')" style="cursor: pointer;">List Price</th>
                                                <th @click="otherSort('mls_beds')" style="cursor: pointer;">Beds</th>
                                                <th @click="otherSort('mls_baths')" style="cursor: pointer;">Baths</th>
                                                <th @click="otherSort('mls_unit_size')" style="cursor: pointer;">Unit Size</th>
                                                <th @click="otherSort('mls_sold_price')" style="cursor: pointer;">Sold Price</th>
                                                <th @click="otherSort('mls_sp_sqft')" style="cursor: pointer;">SP Sqft</th>
                                                <th>FP Specs</th>
                                                <th>Parking</th>
                                                <th>Stalls</th>
                                                <th>Sold Date</th>
                                                <th @click="activeSort('mls_dom')" style="cursor: pointer;">DOM</th>
                                                <th>Status</th>
                                                <th>View</th>
                                                <th>Delete</th>
                                            </thead>
                                            <tbody class="fp-body">
                                                <tr v-for="(d, k) in mlsOtherSort" style="cursor:pointer;" :key="'mls'+k">
                                                    <td v-if="d.mls_floor_plan_feature.fid" v-b-modal="'mls-fp-'+d.mls_floor_plan_feature.fid" class="mls-floorplan">{{d.mls_address}}</td>
                                                    <td v-else v-b-modal="'mls-active-'+d.cid">{{d.mls_address}}</td>
                                                    <td>{{d.mls_pid}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{d.mls_plan_name}}</td>
                                                    <td>{{d.mls_list_date}}</td>
                                                    <td>{{d.mls_price_date}}</td>
                                                    <td v-if="d.mls_list_price > 0" v-b-modal="'mls-other-'+d.cid" >${{d.mls_list_price | numFormat}}</td>
                                                    <td v-else>-</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{(d.mls_beds > 0 || d.mls_beds === '0' || d.mls_beds == 's' || d.mls_beds == 'jr' ) ? d.mls_beds : '-'}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{(d.mls_baths > 0 || d.mls_baths === '0') ? d.mls_baths : '-'}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{(d.mls_unit_size > 0 || d.mls_unit_size === '0') ? d.mls_unit_size : '-'}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid"  v-if="d.mls_sold_price != '-'">${{d.mls_sold_price | numFormat}}</td><td v-else>-</td>
                                                    <td v-b-modal="'mls-other-'+d.cid"  v-if="d.mls_sp_sqft > 0">${{d.mls_sp_sqft | numFormat}}</td><td v-else>-</td>
                                                    <td v-b-modal="'mls-other-'+d.cid">{{d.fp_specs}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid">{{d.stalls}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid">{{d.mls_parking}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{d.mls_sold_date}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{d.mls_dom}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{d.mls_status}}</td>
                                                    <td v-b-modal="'mls-other-'+d.cid" >{{d.orientation == "None" ? '' : d.orientation}}</td>
                                                    <td @click="deleteMLS(d.cid)" style="cursor: pointer;">Delete</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <b-modal v-for="(d, k) in project.mls_last_date_other" :id="'mls-fp-'+d.mls_floor_plan_feature.fid" hide-footer :key="'other'+k">
                                            <div v-if="d.mls_floor_plan_feature.fid" class="col-md-4 d-block text-center">
                                                <a target="_blank" :href="d.mls_floor_plan_feature.link"><img class='floorplan-pdf' :src="d.mls_floor_plan_feature.preview"></a>
                                            </div>
                                        </b-modal>
                                        <b-modal v-for="(v_o, k_o) in project.mls_data" :id="'mls-other-'+k_o" hide-footer :key="'mls_data'+k_o">
                                            <div class="row">
                                                <div class="col-md-4 text-left h5" style="cursor: pointer;">
                                                    Unit: <span v-if="v_o[v_o.length-1].mls_floor_plan_feature.fid" v-b-modal="'mls-fp-'+v_o[v_o.length-1].mls_floor_plan_feature.fid" class="mls-floorplan">{{v_o[v_o.length-1].mls_address}}</span>
                                                    <span v-else>{{v_o[v_o.length-1].mls_address}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Plan Name: <span>{{v_o[v_o.length-1].mls_plan_name}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Beds: <span>{{v_o[v_o.length-1].mls_beds}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    Baths: <span>{{v_o[v_o.length-1].mls_baths}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Unit Size: <span>{{v_o[v_o.length-1].mls_unit_size}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    View: <span>{{v_o[v_o.length-1].orientation == "None" ? '' : v_o[v_o.length-1].orientation}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    Parking: <span>{{v_o[v_o.length-1].stalls}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Stalls: <span>{{v_o[v_o.length-1].mls_parking}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Locker: <span>{{v_o[v_o.length-1].mls_locker}}</span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-4 text-left h5">
                                                    GST included: <span>{{v_o[v_o.length-1].mls_get_included}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    PID: <span>{{v_o[v_o.length-1].mls_pid}}</span>
                                                </div>
                                                <div class="col-md-4 text-left h5">
                                                    Levels: <span>{{v_o[v_o.length-1].levels}}</span>
                                                </div>
                                            </div>
                                            <table class="table mt-3">
                                                <thead class="fp-header">
                                                    <th>List date</th>
                                                    <th>List Price</th>
                                                    <th>Price Date</th>
                                                    <th>Sold Price</th>
                                                    <th>SP Sqft</th>
                                                    <th>Sold Date</th>
                                                    <th>DOM</th>
                                                    <th>Status</th>
                                                    <th>Collection Type</th>
                                                    <th>FP Specs</th>
                                                    <th>Approval</th>
                                                    <th>Edit</th>
                                                    <th>Delete</th>
                                                </thead>
                                                <tbody class="fp-body">
                                                    <tr v-for="(v_i, k_i) in v_o" :key="'vo'+k_i">
                                                        <td>{{v_i.mls_list_date}}</td>
                                                        <td v-if="v_i.mls_list_price > 0">${{v_i.mls_list_price | numFormat}}</td>
                                                        <td v-else>-</td>
                                                        <td>{{v_i.mls_price_date}}</td>
                                                        <td v-if="v_i.mls_sold_price != '-'">${{v_i.mls_sold_price | numFormat}}</td><td v-else>-</td>
                                                        <td v-if="v_i.mls_sp_sqft > 0">${{v_i.mls_sp_sqft | numFormat}}</td><td v-else>-</td>
                                                        <td>{{v_i.mls_sold_date}}</td>
                                                        <td>{{v_i.mls_dom}}</td>
                                                        <td>{{v_i.mls_status}}</td>
                                                        <td>{{v_i.collection_type}}</td>
                                                        <td>{{v_i.fp_specs}}</td>
                                                        <td v-if="v_i.mls_need_approval == 1" @click="approveMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">Approve</td>
                                                        <td v-else @click="unApproveMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">UnApprove</td>
                                                        <td @click.right="editMLSEntryNew(v_i.cid, v_i.entry)" @click="editMLSEntry(v_i.cid, v_i.entry)" style="cursor: pointer;">Edit</td>
                                                        <td @click="deleteMLSEntry(v_i.cid, v_i.entry, k_o, k_i)" style="cursor: pointer;">Delete</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </b-modal>
                                    </template>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="Availability" :active="openTab === 'availability'" v-if="project.is_admin">
                            <div class="row py-3">
                                <div class="col-md-12">
                                    <div class="row text-left">
                                        <div class="col-4 mb-3" style="font-style: normal;
                                            font-weight: 800;
                                            font-size: 17px;
                                            line-height: 18px;
                                            color: #4D7CE1;">
                                            Current Availability
                                        </div>
                                    </div>
                                    <div class="row text-left">
                                        <div class="col-md-7">
                                            <div class="row">
                                                <div style="padding-left: 15px;">
                                                    <div class="ft-avg-label mb-2">Units</div>
                                                    <div class="ft-avg-content" style="padding-right: 50px; border-right: solid 2px #000;">{{project.unit_component.available}}</div>
                                                </div>
                                                <div style="margin-left: 50px;">
                                                    <div class="ft-avg-label mb-2">Avg Size</div>
                                                    <div class="ft-avg-content" style="padding-right: 50px; border-right: solid 2px #000;">{{project.unit_component.active_avg_size | numFormat}}</div>
                                                </div>
                                                <div style="margin-left: 50px;">
                                                    <div class="ft-avg-label mb-2">Avg Price</div>
                                                    <div class="ft-avg-content" style="padding-right: 50px; border-right: solid 2px #000;">${{project.unit_component.active_avg_price | numFormat}}</div>
                                                </div>
                                                <div style="margin-left: 50px;">
                                                    <div class="ft-avg-label mb-2">Avg $PSF</div>
                                                    <div class="ft-avg-content">${{project.unit_component.active_avg_psf | numFormat}}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="project.unit_component.activeBed && project.unit_component.activeBed.length !== 0">
                                        <table class="table mt-3">
                                            <thead class="fp-header">
                                                <!-- <th>Plan Name</th> -->
                                                <th>Beds</th>
                                                <th>FP Specs</th>
                                                <th>Baths</th>
                                                <th># Units</th>
                                                <th>Parking</th>
                                                <th>Stalls</th>
                                                <th>Min SF</th>
                                                <th>Max SF</th>
                                                <th>Avg SF</th>
                                                <th>Min Price</th>
                                                <th>Max Price</th>
                                                <th>Avg Price</th>
                                                <th>Avg $PSF</th>
                                            </thead>
                                            <tbody class="fp-body">
                                                <tr style="cursor: pointer;" v-b-modal="'mls-unit-sold-'+unit_key" v-for="(unit_t, unit_key) in mlsAvailTotalSort" v-bind:key="unit_key">
                                                    <!-- <td v-if="typeof unit_t.plan_name != 'undefined'">{{unit_t.plan_name.join(', ')}}</td>
                                                    <td v-else></td> -->
                                                    <td v-if="unit_t.bed == '-'">{{unit_t.bed}}</td>
                                                        <td v-else>{{unit_t.bed ? unit_t.bed : '0'}}-bed</td>
                                                    <td>{{unit_t.fp_specs}}</td>
                                                    <td>{{unit_t.bath}}</td>
                                                    <td>{{unit_t.num}}</td>
                                                    <td>{{unit_t.parking}}</td>
                                                    <td>{{unit_t.stall ? unit_t.stall.final : ''}}</td>
                                                    <td>{{unit_t.minSize | numFormat}}</td>
                                                    <td>{{unit_t.maxSize | numFormat}}</td>
                                                    <td>{{unit_t.total_size*1.0 / unit_t.num | numFormat}}</td>
                                                    <td>{{unit_t.minPrice ? '$'+numberWithCommas(unit_t.minPrice) : '-'}}</td>
                                                    <td>{{unit_t.maxPrice ? '$'+numberWithCommas(unit_t.maxPrice) : '-'}}</td>
                                                    <td>{{unit_t.avgPrice ? '$'+numberWithCommas(unit_t.avgPrice) : '-'}}</td>
                                                    <td>{{(unit_t.avgPrice && unit_t.total_size && unit_t) ? '$'+numberWithCommas((unit_t.avgPrice/(unit_t.total_size/unit_t.num)).toFixed(0)) : '-'}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <b-modal v-for="(unit_t, unit_key) in mlsAvailTotalSort" v-bind:key="unit_key" :id="'mls-unit-sold-'+unit_key" hide-footer>
                                             <template #modal-header="{ close }">
                                                    <!-- Emulate built in modal header close button action -->
                                                    <h5>FLOOR PLAN BREAKDOWN</h5>
                                                    <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal">
                                                    <button type="button" aria-label="Close" class="close modal-close"  @click="close()">×</button>
                                                </template>
                                                <div class="row my-30">
                                                    <div class="col-xs-6 text-left">
                                                        <a :href="project.web_link[0]" target="_blank" ><h2><strong>{{project.project_name}}</strong></h2></a>
                                                    </div>
                                                    <div class="col-sm-6 text-right">
                                                        <div class="modal-address">{{project.address}}</div>
                                                    </div>
                                                </div>
                                                <table class="table text-left table-borderless plan-table">
                                                    <thead>
                                                        <th>BED</th>
                                                        <th>BATH</th>
                                                        <th>FP SPECS</th>
                                                        <th>SF</th>
                                                        <th>PLAN NAME</th>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td class="bed-column">
                                                                {{unit_t.bed ? unit_t.bed : '0'}}-bed
                                                            </td>
                                                            <td>
                                                                {{unit_t.bath ? unit_t.bath : '0'}}-bath
                                                            </td>
                                                            <td>{{unit_t.fp_specs}}</td>
                                                            <td>
                                                                {{unit_t.minSize | numFormat}} - {{unit_t.maxSize | numFormat}} SF
                                                            </td>
                                                            <td>
                                                                <span v-if="(typeof unit_t.plan_name != 'undefined')">{{unit_t.plan_name.join(', ')}}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div class="col-xs-6 d-block text-center" v-for="(file, file_key) in unit_t.floor_plan" :key="file_key">
                                                    <div class="row fp-img"><a target="_blank" :href="file.link"><img class='floorplan-pdf' :src="file.preview"></a></div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4"><b>Unit #</b></div>
                                                        <div class="col-xs-4"><b>Status</b></div>
                                                        <div class="col-xs-4" v-if="file.status == 'Active'"><b>List Price</b></div>
                                                        <div class="col-xs-4" v-else><b>Sold Price</b></div>
                                                    </div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4">{{file.unit_num}}</div>
                                                        <div class="col-xs-4">{{file.status}}</div>
                                                        <div v-if="file.status == 'Active'" class="col-xs-4">{{file.list_price ? '$'+numberWithCommas(file.list_price) : '$0'}}</div>
                                                        <div v-else class="col-xs-4">{{file.sold_price ? '$'+numberWithCommas(file.sold_price) : '$0'}}</div>
                                                    </div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4"><b>Beds</b></div>
                                                        <div class="col-xs-4"><b>Baths</b></div>
                                                        <div class="col-xs-4"><b>Size</b></div>
                                                    </div>
                                                    <div class="row floor-plan-block">
                                                        <div class="col-xs-4">{{unit_t.bed ? unit_t.bed : '0'}}</div>
                                                        <div class="col-xs-4">{{unit_t.bath ? unit_t.bath : '0'}}</div>
                                                        <div class="col-xs-4">{{file.unit_size}}</div>
                                                    </div>
                                                </div>
                                        </b-modal>
                                    </template>
                                </div>
                            </div>
                        </b-tab>
                        <b-tab title="Development Stats" :active="openTab === 'developmentstats'">
                            <ProjectTypeUTC :groupInfo="typeGroup" :utcInfo="utcExtra"></ProjectTypeUTC>
                        </b-tab>
                        <b-tab title="Permits" :active="openTab === 'permits'">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h2 class="table-header-text text-left">Permits and Bylaws</h2>
                                        <table class="table text-left">
                                            <thead class="table-borderless fp-header" style="background: #12283FE5;">
                                                <th>TYPE</th>
                                                <th><div style="margin-left: 30px;">STATUS</div></th>
                                                <th>SUBMISSION DATE</th>
                                                <th>STATUS DATE</th>
                                                <th># Month</th>
                                            </thead>
                                            <tbody>
                                                <tr v-if="project.sd_sub_date || project.sd_app_date">
                                                    <td><b>Subdivision Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.sd_status)">⬤ {{project.sd_status}}</span></td>
                                                    <td>{{project.sd_sub_date ? project.sd_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.ss_sub_date || project.ss_app_date">
                                                    <td><b>Site Servicing Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.ss_status)">⬤ {{project.ss_status}}</span></td>
                                                    <td>{{project.ss_sub_date ? project.ss_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr>
                                                    <td><b>Rezoning</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.rz_status)">⬤ {{project.rz_status}}</span></td>
                                                    <td>{{project.rz_sub_date ? project.rz_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.rz_fsr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First and Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_fsr_diff.app ? project.rz_fsr_diff.app : '-'}}</td>
                                                    <td>{{project.rz_fsr_diff.month ? project.rz_fsr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_fr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_fr_diff.app ? project.rz_fr_diff.app : '-'}}</td>
                                                    <td>{{project.rz_fr_diff.month ? project.rz_fr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_sr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_sr_diff.app ? project.rz_sr_diff.app : '-'}}</td>
                                                    <td>{{project.rz_sr_diff.month ? project.rz_sr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_app_diff.app ? project.rz_app_diff.app : '-'}}</td>
                                                    <td>{{project.rz_app_diff.month ? project.rz_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.rz_adopt_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Adoption</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.rz_adopt_diff.app ? project.rz_adopt_diff.app : '-'}}</td>
                                                    <td>{{project.rz_adopt_diff.month ? project.rz_adopt_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.oa_sub_date || project.oa_app_date">
                                                    <td><b>OCP Amendment Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.oa_status)">⬤ {{project.oa_status}}</span></td>
                                                    <td>{{project.oa_sub_date ? project.oa_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.ocp_fsr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First and Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_fsr_diff.app ? project.ocp_fsr_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_fsr_diff.month ? project.ocp_fsr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_fr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">First Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_fr_diff.app ? project.ocp_fr_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_fr_diff.month ? project.ocp_fr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_sr_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Second Reading</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_sr_diff.app ? project.ocp_sr_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_sr_diff.month ? project.ocp_sr_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_app_diff.app ? project.ocp_app_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_app_diff.month ? project.ocp_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.ocp_adopt_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Adoption</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.ocp_adopt_diff.app ? project.ocp_adopt_diff.app : '-'}}</td>
                                                    <td>{{project.ocp_adopt_diff.month ? project.ocp_adopt_diff.month : '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Development Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.dp_status)">⬤ {{project.dp_status}}</span></td>
                                                    <td>{{project.dp_sub_date ? project.dp_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.dp_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dp_app_diff.app ? project.dp_app_diff.app : '-'}}</td>
                                                    <td>{{project.dp_app_diff.month ? project.dp_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.dp_issuance_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Issuance</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dp_issuance_diff.app ? project.dp_issuance_diff.app : '-'}}</td>
                                                    <td>{{project.dp_issuance_diff.month ? project.dp_issuance_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.dvp_sub_date || project.dvp_app_date">
                                                    <td><b>Development Variance Application</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.dvp_status)">⬤ {{project.dvp_status}}</span></td>
                                                    <td>{{project.dvp_sub_date ? project.dvp_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.dvp_app_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Approval</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dvp_app_diff.app ? project.dvp_app_diff.app : '-'}}</td>
                                                    <td>{{project.dvp_app_diff.month ? project.dvp_app_diff.month : '-'}}</td>
                                                </tr>
                                                <tr v-if="project.dvp_issuance_diff">
                                                    <td><span class="st-symbol">⤷</span> <span class="st-label">Issuance</span></td>
                                                    <td></td>
                                                    <td></td>
                                                    <td>{{project.dvp_issuance_diff.app ? project.dvp_issuance_diff.app : '-'}}</td>
                                                    <td>{{project.dvp_issuance_diff.month ? project.dvp_issuance_diff.month : '-'}}</td>
                                                </tr>
                                                <tr>
                                                    <td><b>Building Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.bp_status)">⬤ {{project.bp_status}}</span></td>
                                                    <td>{{project.bp_sub_date ? project.bp_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                                <tr v-if="project.demolition_sub_date || project.demolition_app_date">
                                                    <td><b>Demolition Permit</b></td>
                                                    <td class="text-left status-col"><span class="status-cell" :class="statusSwitch(project.demolition_status)">⬤ {{project.demolition_status}}</span></td>
                                                    <td>{{project.demolition_sub_date ? project.demolition_sub_date : '-'}}</td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="row mt-5">
                                    <div class="col-md-12">
                                        <h2 style="float: left;" class="table-header-text text-left">PLANNING PROCESS</h2><span class="hidden-xs hidden-sm hidden-md btn btn-primary-reverse" style="float: right; margin-top: 20px;" v-b-modal="'planning-docs'">Planning Docs</span>
                                        <table class="table">
                                            <thead class="fp-header">
                                                <th>Date</th>
                                                <th>Application Type</th>
                                                <th>Application Stage</th>
                                                <th>Outcome</th>
                                                <th>CBA Status</th>
                                            </thead>
                                            <tbody class="fp-body fp-border">
                                                <tr class="planning-table-cell" v-for="(val, key) in permitSort" :key="key">
                                                    <td class="text-center">
                                                        <a v-if="val.file" :href="val.file" target="_blank">{{val.time}}</a>
                                                        <div v-else>{{val.time}}</div>
                                                    </td>
                                                    <td class="text-center">{{val.col_1}}</td>
                                                    <td class="text-center">{{val.col_2}}</td>
                                                    <td class="text-center" v-html="(val.col_3 ? val.col_3 : '') + (val.col_4 ? '<br>'+val.col_4: '') + (val.col_5 ? '<br>'+val.col_5: '') + (val.col_6 ? '<br>'+val.col_6: '')"></td>
                                                    <td>
                                                        <div v-if="val.rz">REZ: {{val.rz}}</div>
                                                        <div v-if="val.dp">DP: {{val.dp}}</div>
                                                        <div v-if="val.dvp">DVP: {{val.dvp}}</div>
                                                        <div v-if="val.sub">Sub: {{val.sub}}</div>
                                                        <div v-if="val.srv">Serv: {{val.srv}}</div>
                                                        <div v-if="val.demo">Demo: {{val.demo}}</div>
                                                        <div v-if="val.ocp">OCP: {{val.ocp}}</div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <span class="btn btn-primary-reverse hidden-lg" style="float: right; margin-top: 20px;" v-b-modal="'planning-docs'">Planning Docs</span>
                                    </div>
                                </div>
                            </div>
                            <b-modal id="planning-docs" hide-footer title="Planning Docs">
                                <table class="table">
                                    <thead class="fp-header">
                                        <th>File Type</th>
                                        <th>Date</th>
                                    </thead>
                                    <tbody class="fp-body">
                                        <tr v-for="(d, key) in project.city_app" :key="'plan'+key">
                                            <td><a :href="d.planning_doc_file.uri" target="_blank">{{d.planning_doc_file.filename}}</a></td>
                                            <td>{{d.date}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </b-modal>
                        </b-tab>
                        <b-tab v-if="project.status != 'Selling Soon' && project.status != 'In Planning'" title="Notes" :active="openTab === 'notes'">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-12">
                                        <h2 class="table-header-text text-left">NOTES</h2>
                                        <div class="note-wrapper">
                                            <div class="type-note" v-for="(note, key) in project.note" :key="key">
                                                <div class="note-item">
                                                    <div class="note-date">Date: {{note.date}}</div>
                                                    <td class="text-left note-body" v-html="note.note"></td>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                        <!-- <b-tab title="Upload"  v-if="project.is_admin"> -->
                        <b-tab title="Upload" v-if="project.is_admin" :active="openTab === 'upload'">
                            <template>
                                <img class="upload-spinner" v-if="upload_is_loading" src="/images/spinner.gif">
                                <div class="text-left">
                                    <b-form v-on:submit.prevent="mlsUpload">
                                        <label class="typo__label">CSV Import:</label>
                                        <b-form-group id="input-group-6">
                                            <b-form-file
                                                v-model="uploadForm.importCSV"
                                                :state="Boolean(uploadForm.importCSV)"
                                                placeholder="Choose a file or drop it here..."
                                                drop-placeholder="Drop file here..."
                                                ></b-form-file>
                                        </b-form-group>
                                        <label class="typo__label">Floor plan upload:</label>
                                        <b-form-group id="input-group-5">
                                            <b-form-file
                                                v-model="uploadForm.floorPlan"
                                                :state="Boolean(uploadForm.floorPlan)"
                                                placeholder="Choose a file or drop it here..."
                                                drop-placeholder="Drop file here..."
                                                ></b-form-file>
                                        </b-form-group>
                                        <b-form-group id="input-group-list-pid" label="PID:" label-for="upload-list-pid">
                                            <b-form-input v-model="uploadForm.pid" id="upload-list-pid" type="text" placeholder="PID"></b-form-input>
                                        </b-form-group>
                                        <div class="row">
                                            <div class="col-3">
                                                <b-form-group id="input-group-list-unit" label="Unit:" label-for="upload-list-unit">
                                                    <b-form-input v-model="uploadForm.unit" id="upload-list-unit" type="text" placeholder="Unit Number"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div v-if="project.is_admin" class="col-9 pt-4">
                                                {{project.short_address}}
                                            </div>
                                        </div>
                                        <b-form-group id="input-group-list-plan-name" label="Plan Name:" label-for="upload-list-plan-name">
                                            <b-form-input v-model="uploadForm.planName" id="upload-list-plan-name" type="text" placeholder="Plan Name"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-list-bed" label="Beds:" label-for="upload-list-bed">
                                            <b-form-input v-model="uploadForm.bed" id="upload-list-bed" type="text" placeholder="Beds"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-list-bath" label="Bath:" label-for="upload-list-bath">
                                            <b-form-input v-model="uploadForm.bath" id="upload-list-bath" type="text" placeholder="Bath"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-list-unit-size" label="Unit Size:" label-for="upload-list-unit-size">
                                            <b-form-input v-model="uploadForm.unitSize" id="upload-list-unit-size" type="text" placeholder="Unit Size"></b-form-input>
                                        </b-form-group>
                                        <label class="typo__label">FP Specs:</label>
                                        <multiselect v-model="uploadForm.fp" :options="mlsFP" :multiple="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="" label="name" track-by="value">
                                            <template slot="selection" slot-scope="{ values, isOpen }"><span class="multiselect__single" v-if="values.length && !isOpen">{{ values.length }} options selected</span></template>
                                        </multiselect>
                                        <b-form-group id="input-group-orientation" label="View Orientation:" label-for="upload-orientation">
                                            <b-form-select id="upload-orientation" v-model="uploadForm.orientation" :options="mlsOrientation"></b-form-select>
                                        </b-form-group>
                                        <b-form-group id="input-group-floor-level" label="Floor Level:" label-for="upload-floor-level">
                                            <b-form-select id="upload-floor-level" v-model="uploadForm.fl" :options="mlsFloorLevel"></b-form-select>
                                        </b-form-group>
                                        <label for="upload-list-date">List Date</label>
                                        <b-form-datepicker id="upload-list-date" v-model="uploadForm.listDate" reset-button class="mb-2"></b-form-datepicker>
                                        <b-form-group id="input-group-list-price" label="List Price:" label-for="upload-list-price">
                                            <b-form-input v-model="uploadForm.listPrice" id="upload-list-price" type="text" placeholder="List Price"></b-form-input>
                                        </b-form-group>
                                        <label for="upload-list-price-date">List Price Date</label>
                                        <b-form-datepicker id="upload-list-price-date" v-model="uploadForm.listPriceDate" reset-button class="mb-2"></b-form-datepicker>
                                        <b-form-group id="input-group-parking" label="Parking:" label-for="upload-parking">
                                            <b-form-input v-model="uploadForm.parking" id="upload-parking" type="text" placeholder="Parking"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-parking" label="Parking:" label-for="upload-parking">
                                            <b-form-select id="upload-parking" v-model="uploadForm.pr" :options="mlsParking"></b-form-select>
                                        </b-form-group>
                                        <b-form-group id="input-group-locker" label="Locker:" label-for="locker">
                                            <b-form-input v-model="uploadForm.locker" id="upload-locker" type="text" placeholder="Locker"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-gst" label="GST Included:" label-for="upload-gst">
                                            <b-form-input v-model="uploadForm.gst" id="upload-gst" type="text" placeholder="GST Included"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-buyer-incentives" label="Buyer Incentives:" label-for="upload-buyer-incentives">
                                            <b-form-input v-model="uploadForm.buyerIncentives" id="upload-buyer-incentives" type="text" placeholder="Buyer Incentives"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-realtor-incentives" label="Realtor Incentives:" label-for="upload-realtor-incentives">
                                            <b-form-input v-model="uploadForm.realtorIncentives" id="upload-realtor-incentives" type="text" placeholder="Realtor Incentives"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="input-group-status" label="Status:" label-for="upload-status">
                                            <b-form-select id="upload-status" v-model="uploadForm.status" :options="mlsStatus"></b-form-select>
                                        </b-form-group>
                                        <label for="upload-sold-date">Sold Date</label>
                                        <b-form-datepicker id="upload-sold-date" v-model="uploadForm.soldDate" reset-button class="mb-2"></b-form-datepicker>
                                        <b-form-group id="input-group-sold-price" label="Sold Price:" label-for="upload-sold-price">
                                            <b-form-input v-model="uploadForm.soldPrice" id="upload-sold-price" type="text" placeholder="Sold Price"></b-form-input>
                                        </b-form-group>
                                        <b-form-group id="upload-group-assignment">
                                            <b-form-checkbox-group id="update-assignment">
                                            <b-form-checkbox v-model="uploadForm.assignment">Assignment</b-form-checkbox>
                                            </b-form-checkbox-group>
                                        </b-form-group>

                                        <b-form-group id="upload-group-new-entry">
                                            <b-form-checkbox-group id="update-new-entry">
                                            <b-form-checkbox v-model="uploadForm.newEntry">New Entry</b-form-checkbox>
                                            </b-form-checkbox-group>
                                        </b-form-group>

                                        <b-form-group id="upload-group-original-entry">
                                            <b-form-checkbox-group id="update-original-entry">
                                            <b-form-checkbox v-model="uploadForm.originalEntry">Original Entry</b-form-checkbox>
                                            </b-form-checkbox-group>
                                        </b-form-group>

                                        <b-button type="submit" variant="primary">Submit</b-button>
                                    </b-form>
                                </div>
                                </template>
                        </b-tab>
                        <b-tab title="Project History" v-if="project.is_admin" :active="openTab === 'history'">
                            <table class="table mt-3">
                                <thead class="fp-header">
                                    <th>Date</th>
                                    <th>Total Units</th>
                                    <th>Rlsd Units</th>
                                    <th>Total Sold</th>
                                    <th>Avail</th>
                                    <th>Total $PSF</th>
                                    <th>Total Avg Size</th>
                                    <th>Total Avg Price</th>
                                    <th>Current $PSF</th>
                                    <th>Current Avg Size</th>
                                    <th>Current Avg Price</th>
                                </thead>
                                <tbody class="fp-body row-grey">
                                    <tr v-for="(history, history_k) in project.attr_history" :key="history_k">
                                        <td>{{history.date}}</td>
                                        <td>{{history.total}}</td>
                                        <td>{{history.rlsd_units}}</td>
                                        <td>{{history.sold_total}}</td>
                                        <td>{{history.available}}</td>
                                        <td>{{history.avg_psf}}</td>
                                        <td>{{history.avg_size}}</td>
                                        <td>{{history.avg_price}}</td>
                                        <td>{{history.active_avg_psf}}</td>
                                        <td>{{history.active_avg_size}}</td>
                                        <td>{{history.active_avg_price}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <Bar
                                :chart-options="chartOptions"
                                :chart-data="chartDataSale"
                                :height="300"
                            />

                            <Bar
                                :chart-options="chartOptions"
                                :chart-data="chartDataPSF"
                                :height="300"
                            />
                        </b-tab>
                    </b-tabs>
                    <img class="tab-logo hidden-md hidden-sm hidden-xs" src="/images/assets/logo/PRDB_logotype_multicolor.png">
                </div>
                <b-modal id="feature-files" hide-footer>
                    <template #modal-header="{ close }">
                        <!-- Emulate built in modal header close button action -->
                        <h5>FEATURE FILES</h5>
                        <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal">
                        <button type="button" aria-label="Close" class="close modal-close"  @click="close()">×</button>
                    </template>
                    <div class="row my-30">
                        <div class="col-xs-6 text-left">
                            <a :href="project.web_link[0]" target="_blank" ><h2><strong>{{project.project_name}}</strong></h2></a>
                        </div>
                        <div class="col-xs-6 text-right">
                            <div class="modal-address">{{project.address}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6 d-block text-center" v-for="(file, file_k) in project.date_based_features" :key="file_k">
                            <a target="_blank" :href="file.link"><img class='floorplan-pdf' :src="file.preview"></a>
                        </div>
                    </div>
                </b-modal>
                <b-modal id="site-plan-files" hide-footer>
                    <template #modal-header="{ close }">
                        <!-- Emulate built in modal header close button action -->
                        <h5>SITE PLAN</h5>
                        <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal">
                        <button type="button" aria-label="Close" class="close modal-close"  @click="close()">×</button>
                    </template>
                    <div class="row my-30">
                        <div class="col-xs-6 text-left">
                            <a :href="project.web_link[0]" target="_blank" ><h2><strong>{{project.project_name}}</strong></h2></a>
                        </div>
                        <div class="col-sm-6 text-right">
                            <div class="modal-address">{{project.address}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-6 d-block text-center site-plan-bg" v-for="(file, file_k) in project.site_plan_features" :key="file_k">
                        <a target="_blank" :href="file.link"><img class='floorplan-pdf' :src="file.preview"></a>
                        </div>
                    </div>
                </b-modal>
                <!-- <b-modal id="feature-files" hide-footer>
                    <div class="col-xs-4 d-block text-center" v-for="file in project.date_based_features">
                        <a target="_blank" :href="file.link"><img class='floorplan-pdf' :src="file.preview"></a>
                    </div>
                </b-modal> -->
            </div>
        </div>
        <b-modal id="consultant" hide-footer :title="'Consultant Information'">
            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <h5>Consultant Information</h5>
                <img src="/images/assets/logo/RPD_logotype_skyblue.png" class="logo-modal">
                <button type="button" aria-label="Close" class="close modal-close"  @click="close()">×</button>
            </template>
            <div class="row my-30">
                <div class="col-xs-6 text-left">
                    <a :href="project.web_link[0]" target="_blank" ><h2><strong>{{project.project_name}}</strong></h2></a>
                </div>
                <div class="col-sm-6 text-right">
                    <div class="modal-address">{{project.address}}</div>
                </div>
            </div>
            <table class="table text-left modal-table">
                <tbody style="border-top: 2px #545454 solid;">
                    <tr v-for="(consultant, key_c) in project.consultant" :key="key_c">
                        <td>{{consultant.type}}</td>
                        <td>{{consultant.name}}</td>
                    </tr>
                </tbody>
            </table>
        </b-modal>
    </section>
</template>
<script>
    import {BTabs, BTab, BModal, BModalDirective, VBModal, BForm, BFormGroup, 
    BFormInput, BFormSelect, BFormCheckbox, BFormCheckboxGroup,  BButton, BFormFile, BFormDatepicker} from 'bootstrap-vue';
    import VueGallery from 'vue-gallery';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faBuilding } from '@fortawesome/free-regular-svg-icons';
    import { faRulerVertical, faHome, faStore, faBed, faShareSquare, faArrowCircleRight, faArrowCircleLeft} from '@fortawesome/free-solid-svg-icons';
    import pdf from 'vue-pdf';
    import {BACKEND_URL} from '../variables.js';
    import { Carousel, Slide } from 'vue-carousel';
    import Multiselect from 'vue-multiselect'
    import { LightGallery } from 'vue-light-gallery';
    import { ProjectTypeUTC } from '../shared/components'
    import { Bar } from 'vue-chartjs/legacy'
    import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

    library.add(faBuilding, faRulerVertical, faHome, faStore, faBed, faShareSquare, faArrowCircleRight, faArrowCircleLeft)
    
    export default {
        components: { 
            'gallery': VueGallery,
            'b-modal': BModal,
            'b-tabs': BTabs,
            'b-tab': BTab,
            'b-form': BForm,
            'b-form-group': BFormGroup,
            'b-form-input': BFormInput,
            'b-form-select': BFormSelect,
            'b-form-checkbox': BFormCheckbox,
            'b-form-checkbox-group': BFormCheckboxGroup,
            'b-button': BButton,
            'b-form-file': BFormFile,
            'b-form-datepicker': BFormDatepicker,
            pdf,
            Carousel,
            Slide,
            Multiselect,
            LightGallery,
            Bar,
            ProjectTypeUTC
        },
        directives: {
            'b-modal': VBModal,
        },
        data() {
            return {
                chartDataSale: {
                    labels: [],
                    datasets: [
                        {
                            label: 'Sales History',
                            backgroundColor: '#f87979',
                            data: []
                        }
                    ]
                },
                chartDataPSF: {
                    labels: [],
                    datasets: [
                        {
                            label: 'PSF History',
                            backgroundColor: '#2596be',
                            data: []
                        }
                    ]
                },
                chartOptions: {
                    responsive: true
                },
                chartId: 'test id',
                datasetIdKey: 'test key',
                orderAsc: true,
                activeSortBy: 'mls_address',
                soldSortBy: 'mls_address',
                otherSortBy: 'mls_address',
                project_id: this.$route.query.project,
                collection_ids: this.$route.query.fid,
                type_id: this.$route.query.typeid,
                project: [],
                project_link: '',
                index: null,
                floorPlanPick: '',
                image_lists: [],
                uploadForm: {
                    planName: '',
                    fp: [],
                    orientation: 11105,
                    unit: '',
                    bed: '',
                    bath: '',
                    unitSize: '',
                    listPrice: '',
                    pr: '',
                    locker: '',
                    gst: '',
                    buyerIncentives: '',
                    realtorIncentives: '',
                    status: 11482,
                    soldDate: null,
                    listDate: null,
                    listPriceDate: null,
                    fl: '',
                    files: null,
                    owner: '',
                    purchaser: '',
                    pid: '',
                    assignment: 0,
                    newEntry: 0,
                    originalEntry: 0
                },
                openTab: 'overview',
                mlsOrientation: [
                    {text: 'None', value: 11105},
                    {text: 'East', value: 11033},
                    {text: 'North', value: 11030},
                    {text: 'North East', value: 11035},
                    {text: 'North West', value: 11034},
                    {text: 'South', value: 11032},
                    {text: 'South East', value: 11037},
                    {text: 'South West', value: 11036},
                    {text: 'West', value: 11031},
                ],
                mlsFP: [],
                mlsParking: [],
                mlsFloorLevel: [],
                // mlsStatus: [{text: 'Active', value: 8197}, {text: 'Cancel Protected', value: 8206}, {text: 'Collapsed', value: 8201}, {text: 'Expired', value: 8202}, , {text: 'Withdrawn', value: 8203}
                // , {text: 'Hold All Action', value: 8204}, {text: 'Leased', value: 8208}, {text: 'Rented', value: 8207}, {text: 'Sold', value: 8198}, {text: 'Terminated', value: 8205}],
                mlsStatus: [{text: '', value: 11482}, {text: 'Active', value: 8197}, {text: 'Sold', value: 8198}],
                project_icons: {
                    'Market Strata': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.4167 0.75H2.58333C1.575 0.75 0.75 1.575 0.75 2.58333V15.4167C0.75 16.425 1.575 17.25 2.58333 17.25H15.4167C16.425 17.25 17.25 16.425 17.25 15.4167V2.58333C17.25 1.575 16.425 0.75 15.4167 0.75ZM15.4167 15.4167H2.58333V2.58333H15.4167V15.4167ZM6.25 7.16667H4.41667V13.5833H6.25V7.16667ZM8.08333 4.41667H9.91667V13.5833H8.08333V4.41667ZM13.5833 9.91667H11.75V13.5833H13.5833V9.91667Z" fill="black" fill-opacity="0.54"/></svg>',
                    'Below-Market Rental': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
                    'Market Rental': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
                    'Below-Market Strata': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
                    'Fee Simple': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" fill="black" fill-opacity="0.54"/></svg>',
                    'Commercial': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.75 3.04169V8.54169H17.25V17.7084H0.75V4.87502H6.25V3.04169L9 0.291687L11.75 3.04169ZM2.58333 15.875H4.41667V14.0417H2.58333V15.875ZM4.41667 12.2084H2.58333V10.375H4.41667V12.2084ZM2.58333 8.54169H4.41667V6.70835H2.58333V8.54169ZM8.08333 15.875V14.0417H9.91667V15.875H8.08333ZM8.08333 10.375V12.2084H9.91667V10.375H8.08333ZM8.08333 8.54169V6.70835H9.91667V8.54169H8.08333ZM8.08333 3.04169V4.87502H9.91667V3.04169H8.08333ZM15.4167 15.875H13.5833V14.0417H15.4167V15.875ZM13.5833 12.2084H15.4167V10.375H13.5833V12.2084Z" fill="black" fill-opacity="0.54"/></svg>',
                    'Industrial': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.75 3.04169V8.54169H17.25V17.7084H0.75V4.87502H6.25V3.04169L9 0.291687L11.75 3.04169ZM2.58333 15.875H4.41667V14.0417H2.58333V15.875ZM4.41667 12.2084H2.58333V10.375H4.41667V12.2084ZM2.58333 8.54169H4.41667V6.70835H2.58333V8.54169ZM8.08333 15.875V14.0417H9.91667V15.875H8.08333ZM8.08333 10.375V12.2084H9.91667V10.375H8.08333ZM8.08333 8.54169V6.70835H9.91667V8.54169H8.08333ZM8.08333 3.04169V4.87502H9.91667V3.04169H8.08333ZM15.4167 15.875H13.5833V14.0417H15.4167V15.875ZM13.5833 12.2084H15.4167V10.375H13.5833V12.2084Z" fill="black" fill-opacity="0.54"/></svg>',
                    'Fee-Simple': '<svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.0002 0.75V4.41667H19.1668V17.25H0.833496V0.75H10.0002ZM2.66683 15.4167H4.50016V13.5833H2.66683V15.4167ZM4.50016 11.75H2.66683V9.91667H4.50016V11.75ZM2.66683 8.08333H4.50016V6.25H2.66683V8.08333ZM4.50016 4.41667H2.66683V2.58333H4.50016V4.41667ZM6.3335 15.4167H8.16683V13.5833H6.3335V15.4167ZM8.16683 11.75H6.3335V9.91667H8.16683V11.75ZM6.3335 8.08333H8.16683V6.25H6.3335V8.08333ZM8.16683 4.41667H6.3335V2.58333H8.16683V4.41667ZM17.3335 15.4167V6.25H10.0002V8.08333H11.8335V9.91667H10.0002V11.75H11.8335V13.5833H10.0002V15.4167H17.3335ZM15.5002 8.08333H13.6668V9.91667H15.5002V8.08333ZM13.6668 11.75H15.5002V13.5833H13.6668V11.75Z" fill="black" fill-opacity="0.54"/></svg>',
                },
                bed_icons: {
                    'Studio': '<svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.478604 15C0.727478 15 0.918917 14.8504 0.918917 14.656V12.0538H16.1194V14.656C16.1194 14.8504 16.3108 15 16.5597 15C16.8086 15 17 14.8504 17 14.656V11.6949V8.95813C17 8.88335 16.9617 8.80857 16.9043 8.74875L13.152 4.96511V0.343969C13.152 0.149552 12.9606 0 12.7117 0H4.28829C4.03941 0 3.84797 0.149552 3.84797 0.343969V4.96511L0.0957207 8.74875C0.0382883 8.80857 0 8.88335 0 8.95813V11.6949V14.656C0.0382883 14.8355 0.22973 15 0.478604 15ZM4.53716 5.42871H6.58559H8.51915H10.4527H12.5011L15.6599 8.61416H1.37838L4.53716 5.42871ZM6.06869 4.30708V2.43769C6.06869 2.21336 6.29842 2.01894 6.60473 2.01894H10.4718C10.759 2.01894 11.0079 2.19841 11.0079 2.43769V4.32203C11.0079 4.54636 10.7782 4.74078 10.4718 4.74078H8.53829H6.60473C6.29842 4.72582 6.06869 4.54636 6.06869 4.30708ZM0.918917 9.30209H16.1194V11.336H0.918917V9.30209ZM4.76689 0.687937H12.2905V4.72582H11.7737C11.8311 4.59123 11.8694 4.45663 11.8694 4.30708V2.43769C11.8694 1.82453 11.2376 1.33101 10.4527 1.33101H6.58559C5.80067 1.33101 5.16892 1.82453 5.16892 2.43769V4.32203C5.16892 4.47159 5.20721 4.60618 5.26464 4.74078H4.76689V0.687937Z" fill="#606060"/></svg>',
                    '1-bed': '<svg width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.615 5.65421H16.0541V5.26693C16.0541 5.01521 15.902 4.82157 15.7041 4.82157H9.75422C9.5564 4.82157 9.40423 5.01521 9.40423 5.26693V5.65421H6.83252V5.34439C6.83252 4.37621 6.20862 3.60166 5.44776 3.60166H4.07821C3.31735 3.60166 2.69344 4.39557 2.69344 5.34439V5.71231C2.5717 5.75104 2.46519 5.80912 2.35867 5.88658V1.43291C2.35867 0.638997 1.8565 0 1.23259 0H1.12607C0.502167 0 0 0.638997 0 1.43291V13.5546C0 13.8064 0.15217 14 0.349994 14H2.00867C2.20649 14 2.35867 13.8064 2.35867 13.5546V11.4246H9.73901H15.6889H18.6411V13.5546C18.6411 13.8064 18.7932 14 18.9911 14H20.6497C20.8476 14 20.9997 13.8064 20.9997 13.5546V10.9792V7.43568C21.015 6.44813 20.3758 5.65421 19.615 5.65421ZM19.615 6.54495C19.9954 6.54495 20.315 6.93222 20.315 7.43568V10.5145H19.0063H16.0541V6.54495H19.615ZM3.40865 5.34439C3.40865 4.87966 3.71299 4.49238 4.07821 4.49238H5.44776C5.81297 4.49238 6.11731 4.87966 6.11731 5.34439V5.65421H3.40865V5.34439ZM1.65867 13.0899H0.715206V1.43291C0.715206 1.14246 0.897814 0.910088 1.12607 0.910088H1.24781C1.47607 0.910088 1.65867 1.14246 1.65867 1.43291V7.43568V10.9792V13.0899ZM2.35867 7.43568C2.35867 6.95158 2.66301 6.54495 3.05866 6.54495H6.48253H9.40423V10.5145H2.37388V7.43568H2.35867ZM10.1042 10.5145V5.71231H15.3542V10.5145H10.1042ZM20.2997 13.0899H19.3563V11.4246H20.2997V13.0899Z" fill="#606060"/></svg>',
                    '2-bed': '<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.6915 5.47036H17.4472V0.444591C17.4472 0.193302 17.3074 0 17.1257 0H1.88732C1.70558 0 1.56578 0.193302 1.56578 0.444591V5.47036H0.321542C0.1398 5.47036 0 5.66366 0 5.91495V11.2113V14.5554C0 14.8067 0.1398 15 0.321542 15C0.503284 15 0.643084 14.8067 0.643084 14.5554V11.6559H18.3559V14.5554C18.3559 14.8067 18.4957 15 18.6775 15C18.8592 15 18.999 14.8067 18.999 14.5554V11.2113V5.91495C19.013 5.66366 18.8732 5.47036 18.6915 5.47036ZM2.22285 0.889176H16.8041V5.47036H15.7417C15.8116 5.18042 15.8395 4.89047 15.8395 4.60052C15.8395 3.0348 14.9168 1.75902 13.7844 1.75902H11.5896C10.4572 1.75902 9.53447 3.0348 9.53447 4.60052C9.53447 4.9098 9.57641 5.19975 9.63233 5.47036H9.40864C9.47854 5.18042 9.50651 4.89047 9.50651 4.60052C9.50651 3.0348 8.58381 1.75902 7.45142 1.75902H5.25654C4.12414 1.75902 3.20146 3.0348 3.20146 4.60052C3.20146 4.9098 3.24339 5.19975 3.29931 5.47036H2.23682V0.889176H2.22285ZM10.3313 5.47036C10.2335 5.19975 10.1776 4.9098 10.1776 4.60052C10.1776 3.51804 10.8067 2.6482 11.5896 2.6482H13.7844C14.5673 2.6482 15.1964 3.51804 15.1964 4.60052C15.1964 4.9098 15.1405 5.19975 15.0426 5.47036H10.3313ZM3.98434 5.47036C3.88648 5.19975 3.83057 4.9098 3.83057 4.60052C3.83057 3.51804 4.45967 2.6482 5.24256 2.6482H7.43744C8.22033 2.6482 8.84944 3.51804 8.84944 4.60052C8.84944 4.9098 8.79352 5.19975 8.69566 5.47036H3.98434ZM0.657069 6.35953H3.78862H8.79352C8.82148 6.35953 8.84944 6.37887 8.8774 6.37887C8.90536 6.37887 8.93332 6.37886 8.96128 6.35953H10.0657C10.0937 6.37886 10.1216 6.37887 10.1496 6.37887C10.1776 6.37887 10.2055 6.37886 10.2335 6.35953H15.2384H18.3839V10.7668H0.657069V6.35953Z" fill="#606060"/></svg>',
                    '3-bed': '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.321558 9.55158C0.139807 9.55158 0 9.73095 0 9.96413V11.6144V14.4843V17.5874C0 17.8206 0.139807 18 0.321558 18C0.50331 18 0.643117 17.8206 0.643117 17.5874V14.8969H18.3569V17.5874C18.3569 17.8206 18.4967 18 18.6784 18C18.8602 18 19 17.8206 19 17.5874V14.4843V11.6144V9.96413C19 9.73095 18.8602 9.55158 18.6784 9.55158C18.4967 9.55158 18.3569 9.73095 18.3569 9.96413V10.6637L15.5327 7.3453V2.82512C15.5327 2.64575 15.4489 2.48431 15.3091 2.4305L9.59087 0.0269058C9.52097 -0.00896861 9.45106 -0.00896861 9.38116 0.0269058L3.69095 2.4305C3.55114 2.48431 3.46725 2.64575 3.46725 2.82512V7.3453L0.643117 10.6637V9.96413C0.643117 9.73095 0.489329 9.55158 0.321558 9.55158ZM3.91464 7.93723H7.56365H11.4503H15.0993L17.8536 11.1839H1.14643L3.91464 7.93723ZM6.8646 6.21525V5.33633C6.8646 4.85202 7.17218 4.43947 7.56365 4.43947H11.4503C11.8278 4.43947 12.1494 4.83409 12.1494 5.33633V6.21525C12.1494 6.69955 11.8418 7.11211 11.4503 7.11211H7.56365C7.17218 7.11211 6.8646 6.71749 6.8646 6.21525ZM0.643117 14.0718V12.0269H18.3569V14.0718H0.643117ZM4.11037 3.13005L9.49301 0.852024L14.8756 3.13005V7.11211H12.5828C12.7086 6.84305 12.7785 6.53812 12.7785 6.21525V5.33633C12.7785 4.38566 12.1773 3.61435 11.4363 3.61435H7.54967C6.80868 3.61435 6.2075 4.38566 6.2075 5.33633V6.21525C6.2075 6.53812 6.27741 6.84305 6.40324 7.11211H4.11037V3.13005Z" fill="#606060"/></svg>',
                    '4-bed': '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.321558 9.55158C0.139807 9.55158 0 9.73095 0 9.96413V11.6144V14.4843V17.5874C0 17.8206 0.139807 18 0.321558 18C0.50331 18 0.643117 17.8206 0.643117 17.5874V14.8969H18.3569V17.5874C18.3569 17.8206 18.4967 18 18.6784 18C18.8602 18 19 17.8206 19 17.5874V14.4843V11.6144V9.96413C19 9.73095 18.8602 9.55158 18.6784 9.55158C18.4967 9.55158 18.3569 9.73095 18.3569 9.96413V10.6637L15.5327 7.3453V2.82512C15.5327 2.64575 15.4489 2.48431 15.3091 2.4305L9.59087 0.0269058C9.52097 -0.00896861 9.45106 -0.00896861 9.38116 0.0269058L3.69095 2.4305C3.55114 2.48431 3.46725 2.64575 3.46725 2.82512V7.3453L0.643117 10.6637V9.96413C0.643117 9.73095 0.489329 9.55158 0.321558 9.55158ZM3.91464 7.93723H7.56365H11.4503H15.0993L17.8536 11.1839H1.14643L3.91464 7.93723ZM6.8646 6.21525V5.33633C6.8646 4.85202 7.17218 4.43947 7.56365 4.43947H11.4503C11.8278 4.43947 12.1494 4.83409 12.1494 5.33633V6.21525C12.1494 6.69955 11.8418 7.11211 11.4503 7.11211H7.56365C7.17218 7.11211 6.8646 6.71749 6.8646 6.21525ZM0.643117 14.0718V12.0269H18.3569V14.0718H0.643117ZM4.11037 3.13005L9.49301 0.852024L14.8756 3.13005V7.11211H12.5828C12.7086 6.84305 12.7785 6.53812 12.7785 6.21525V5.33633C12.7785 4.38566 12.1773 3.61435 11.4363 3.61435H7.54967C6.80868 3.61435 6.2075 4.38566 6.2075 5.33633V6.21525C6.2075 6.53812 6.27741 6.84305 6.40324 7.11211H4.11037V3.13005Z" fill="#606060"/></svg>',
                    '5-bed': '<svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.321558 9.55158C0.139807 9.55158 0 9.73095 0 9.96413V11.6144V14.4843V17.5874C0 17.8206 0.139807 18 0.321558 18C0.50331 18 0.643117 17.8206 0.643117 17.5874V14.8969H18.3569V17.5874C18.3569 17.8206 18.4967 18 18.6784 18C18.8602 18 19 17.8206 19 17.5874V14.4843V11.6144V9.96413C19 9.73095 18.8602 9.55158 18.6784 9.55158C18.4967 9.55158 18.3569 9.73095 18.3569 9.96413V10.6637L15.5327 7.3453V2.82512C15.5327 2.64575 15.4489 2.48431 15.3091 2.4305L9.59087 0.0269058C9.52097 -0.00896861 9.45106 -0.00896861 9.38116 0.0269058L3.69095 2.4305C3.55114 2.48431 3.46725 2.64575 3.46725 2.82512V7.3453L0.643117 10.6637V9.96413C0.643117 9.73095 0.489329 9.55158 0.321558 9.55158ZM3.91464 7.93723H7.56365H11.4503H15.0993L17.8536 11.1839H1.14643L3.91464 7.93723ZM6.8646 6.21525V5.33633C6.8646 4.85202 7.17218 4.43947 7.56365 4.43947H11.4503C11.8278 4.43947 12.1494 4.83409 12.1494 5.33633V6.21525C12.1494 6.69955 11.8418 7.11211 11.4503 7.11211H7.56365C7.17218 7.11211 6.8646 6.71749 6.8646 6.21525ZM0.643117 14.0718V12.0269H18.3569V14.0718H0.643117ZM4.11037 3.13005L9.49301 0.852024L14.8756 3.13005V7.11211H12.5828C12.7086 6.84305 12.7785 6.53812 12.7785 6.21525V5.33633C12.7785 4.38566 12.1773 3.61435 11.4363 3.61435H7.54967C6.80868 3.61435 6.2075 4.38566 6.2075 5.33633V6.21525C6.2075 6.53812 6.27741 6.84305 6.40324 7.11211H4.11037V3.13005Z" fill="#606060"/></svg>',
                },
                landInfo: {},
                selectedDateMap: {},
                upload_is_loading: false,
                projectImgindex: null,
                interiorImgindex: null,
                amenityImgindex: null,
                presentationImgindex: null,
                siteImgindex: null,
                constructionImgindex: null,
                typeGroup: null,
                utcExtra: null
                // view: this.$route.query.view,
                // index: null
            }
        },
        mounted: function() {
            this.project_link = '/project?project=' + this.project_id;
            var queryString = '';
            if (typeof this.collection_ids != 'object') {
                queryString += '&fid[]=' + this.collection_ids;
            }
            else {
                this.collection_ids.forEach(element => {
                    queryString += '&fid[]=' + element;
                });
            }

            if (this.$route.query['permit']) {
                this.openTab = 'permits'
            }
            if (this.$route.query.tab == 'unit') {
                this.openTab = 'unitmix'
            }

            const vm = this;
            $.get({
                url: BACKEND_URL + 'api/get_utc?pid=' + this.project_id + queryString + '&sid=' + this.$route.query.sid + '&uid=' + this.$route.query.uid,
            }, (data, status) => {
                if (status === 'success') {
                    vm.project = data;
                    vm.landInfo = data.ltsa_info
                    Object.keys(vm.landInfo).forEach((key) => {
                        vm.selectedDateMap[key] = { selectedDate: Object.keys(vm.landInfo[key].reg)[0] }
                    })
                    vm.floorPlanPick = data.first_floor_plan_key;
                    if (data.quarter_data.length > 0) {
                        Object.keys(data.quarter_data.sale).forEach((key) => {
                            vm.chartDataSale.labels.push(key);
                        })
                        Object.values(data.quarter_data.sale).forEach((val) => {
                            vm.chartDataSale.datasets[0].data.push(val);
                        })
                        Object.keys(data.quarter_data.psf).forEach((key) => {
                            vm.chartDataPSF.labels.push(key);
                        })
                        Object.values(data.quarter_data.psf).forEach((val) => {
                            vm.chartDataPSF.datasets[0].data.push(val);
                        })
                    }
                    if (vm.project.pic_list) {
                        vm.project.pic_list.forEach(element => {
                            vm.image_lists.push(element.url);
                        });
                    }
                    this.$nextTick(function () {
                        // this.$emit('height', this.$el.clientHeight)
                        if (typeof vm.project['geo_info'] != 'undefined') {
                            this.singleMap(vm.project['geo_info']['lat'], vm.project['geo_info']['lng']);
                        }
                        // this.singleMapSecond(vm.project['geo_info']['lat'], vm.project['geo_info']['lng']);
                        // setTimeout(this.$refs.carousel.computeCarouselWidth, 2000)
                    })
                }
            });

            $.get({
                url: BACKEND_URL + 'api/get_single_project?pid=' + this.project_id + '&fid=' + this.$route.query.fid,
            }, (data, status) => {
                if (status === 'success') {
                    vm.typeGroup = data.type_group
                    vm.utcExtra = data.utc_extra
                }
            });

            $.get({
                url: BACKEND_URL + 'api/get_fp_specs',
            }, (data, status) => {
                if (status === 'success') {
                    vm.mlsFP = data.fp_specs;
                    vm.mlsParking = data.parking;
                    vm.mlsFloorLevel = data.floor_level;
                }
            });

        },
        computed: {
            permitSort: function() {
                var ob = [];
                Object.values(this.project.permit_data).forEach(el => {
                    ob.push(el);
                });
                ob = ob.sort(function (a,b) {
                    if (a.timeUnix > b.timeUnix) {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                });
                return ob;
            },
            mlsTotalSort: function () {
                var vm = this;
                var result = [];
                if (typeof vm.project.unit_component.bed != 'undefined') {
                    Object.values(vm.project.unit_component.bed).forEach(el => {
                        Object.values(el).forEach(single => {
                            result.push(single);
                        })
                    });
                    result.sort(function (a,b) {
                        if (a['bed'] == b['bed']) {
                            if (a['bath'] == b['bath']) {
                                if (a['total_size']/a['num'] < b['total_size']/b['num']) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            }
                            else {
                                return (a['bath'] - b['bath']);
                            }
                        }
                        else {
                            return (a['bed'] - b['bed']);
                        }
                    })
                }
                return result.filter(i => i.bed != '');
            },
            mlsAvailTotalSort: function () {
                var vm = this;
                var activeResult = [];
                if (typeof vm.project.unit_component.activeBed != 'undefined') {
                    Object.values(vm.project.unit_component.activeBed).forEach(el => {
                        Object.values(el).forEach(single => {
                            activeResult.push(single);
                        })
                    });
                    activeResult.sort(function (a,b) {
                        if (a['bed'] == b['bed']) {
                            if (a['bath'] == b['bath']) {
                                if (a['total_size']/a['num'] < b['total_size']/b['num']) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            }
                            else {
                                return (a['bath'] - b['bath']);
                            }
                        }
                        else {
                            return (a['bed'] - b['bed']);
                        }
                    })
                }
                return activeResult.filter(i => i.bed != '');
            },
            mlsSoldTotalSort: function () {
                var vm = this;
                if (typeof vm.project.unit_component.bedSold != 'undefined') {
                    var ob = Object.values(vm.project.unit_component.bedSold).sort(function (a,b) {
                        if (a['bed'] == b['bed']) {
                            if (a['bath'] == b['bath']) {
                                if (a['total_size']/a['num'] < b['total_size']/b['num']) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            }
                            else {
                                return (a['bath'] - b['bath']);
                            }
                        }
                        else {
                            return (a['bed'] - b['bed']);
                        }
                    });
                    return ob.filter(i => i.bed != '');
                }
            },
            floorPlanSort: function () {
                return _.orderBy(this.project.date_based_floor_plan_ref[this.floorPlanPick], 'fp_weight');
            },
            avgPlan: function () {
                return this.project.avg_result[this.floorPlanPick];
            },
            mlsSoldSort: function() {
                var ob = this.project.mls_last_date_sold;
                var vm = this;
                if (this.project.mls_last_date_sold.length < 2) {
                    return ob;
                }
                if (this.soldSortBy) {
                    if (this.soldSortBy == 'mls_plan_name') {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_sold.sort(function (a,b) {
                                if (a[vm.soldSortBy] == '' || a[vm.soldSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.soldSortBy] == '' || b[vm.soldSortBy] == null) {
                                    return 1;
                                }
                                if (a[vm.soldSortBy] > b[vm.soldSortBy]) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_sold.sort(function (a,b) {
                                if (a[vm.soldSortBy] == '' || a[vm.soldSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.soldSortBy] == '' || b[vm.soldSortBy] == null) {
                                    return -1;
                                }
                                if (a[vm.soldSortBy] > b[vm.soldSortBy]) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                    else if (this.soldSortBy == 'mls_address') {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_sold.sort(function (a,b) {
                                if (a[vm.soldSortBy] == '' || a[vm.soldSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.soldSortBy] == '' || b[vm.soldSortBy] == null) {
                                    return 1;
                                }
                                if (a[vm.soldSortBy].includes('TH') && b[vm.soldSortBy].includes('TH')) {
                                    if (parseFloat(a[vm.soldSortBy].replace('TH', '')) > parseFloat(b[vm.soldSortBy].replace('TH', ''))) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                                else if (a[vm.soldSortBy].includes('TH') && !b[vm.soldSortBy].includes('TH')) {
                                    return -1;
                                }
                                else if (!a[vm.soldSortBy].includes('TH') && b[vm.soldSortBy].includes('TH')) {
                                    return 1;
                                }
                                if (parseFloat(a[vm.soldSortBy]) > parseFloat(b[vm.soldSortBy])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_sold.sort(function (a,b) {
                                if (a[vm.soldSortBy] == '' || a[vm.soldSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.soldSortBy] == '' || b[vm.soldSortBy] == null) {
                                    return -1;
                                }
                                if (a[vm.soldSortBy].includes('TH') && b[vm.soldSortBy].includes('TH')) {
                                    if (parseFloat(a[vm.soldSortBy].replace('TH', '')) > parseFloat(b[vm.soldSortBy].replace('TH', ''))) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                                else if (a[vm.soldSortBy].includes('TH') && !b[vm.soldSortBy].includes('TH')) {
                                    return 1;
                                }
                                else if (!a[vm.soldSortBy].includes('TH') && b[vm.soldSortBy].includes('TH')) {
                                    return -1;
                                }
                                if (parseFloat(a[vm.soldSortBy]) > parseFloat(b[vm.soldSortBy])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                    else {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_sold.sort(function (a,b) {
                                if (a[vm.soldSortBy] == '' || a[vm.soldSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.soldSortBy] == '' || b[vm.soldSortBy] == null) {
                                    return 1;
                                }
                                if (parseFloat(a[vm.soldSortBy]) > parseFloat(b[vm.soldSortBy])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_sold.sort(function (a,b) {
                                if (a[vm.soldSortBy] == '' || a[vm.soldSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.soldSortBy] == '' || b[vm.soldSortBy] == null) {
                                    return -1;
                                }
                                if (parseFloat(a[vm.soldSortBy]) > parseFloat(b[vm.soldSortBy])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                }
                return ob;
            },
            mlsActiveSort: function() {
                var ob = this.project.mls_last_date_active;
                var vm = this;
                if (this.project.mls_last_date_active.length < 2 ) {
                    return ob;
                }
                if (this.activeSortBy) {
                    if (this.activeSortBy == 'mls_plan_name') {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_active.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (a[vm.activeSortBy] > b[vm.activeSortBy]) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_active.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (a[vm.activeSortBy] > b[vm.activeSortBy]) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                    else if (this.activeSortBy == 'mls_address') {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_active.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    if (parseFloat(a[vm.activeSortBy].replace('TH', '')) > parseFloat(b[vm.activeSortBy].replace('TH', ''))) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                                else if (a[vm.activeSortBy].includes('TH') && !b[vm.activeSortBy].includes('TH')) {
                                    return -1;
                                }
                                else if (!a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    return 1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_active.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    if (parseFloat(a[vm.activeSortBy].replace('TH', '')) > parseFloat(b[vm.activeSortBy].replace('TH', ''))) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                                else if (a[vm.activeSortBy].includes('TH') && !b[vm.activeSortBy].includes('TH')) {
                                    return 1;
                                }
                                else if (!a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    return -1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                    else {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_active.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_active.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                }
                return ob;
            },
            mlsOtherSort: function() {
                var ob = this.project.mls_last_date_other;
                var vm = this;
                if (this.project.mls_last_date_other.length < 2 ) {
                    return ob;
                }
                if (this.activeSortBy) {
                    if (this.activeSortBy == 'mls_plan_name') {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_other.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (a[vm.activeSortBy] > b[vm.activeSortBy]) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_other.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (a[vm.activeSortBy] > b[vm.activeSortBy]) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                    else if (this.activeSortBy == 'mls_address') {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_other.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    if (parseFloat(a[vm.activeSortBy].replace('TH', '')) > parseFloat(b[vm.activeSortBy].replace('TH', ''))) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                                else if (a[vm.activeSortBy].includes('TH') && !b[vm.activeSortBy].includes('TH')) {
                                    return -1;
                                }
                                else if (!a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    return 1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_other.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    if (parseFloat(a[vm.activeSortBy].replace('TH', '')) > parseFloat(b[vm.activeSortBy].replace('TH', ''))) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                                else if (a[vm.activeSortBy].includes('TH') && !b[vm.activeSortBy].includes('TH')) {
                                    return 1;
                                }
                                else if (!a[vm.activeSortBy].includes('TH') && b[vm.activeSortBy].includes('TH')) {
                                    return -1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                    else {
                        if (this.orderAsc) {
                            ob = vm.project.mls_last_date_other.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                        }
                        else {
                            ob = vm.project.mls_last_date_other.sort(function (a,b) {
                                if (a[vm.activeSortBy] == '' || a[vm.activeSortBy] == null) {
                                    return 1;
                                }
                                if (b[vm.activeSortBy] == '' || b[vm.activeSortBy] == null) {
                                    return -1;
                                }
                                if (parseFloat(a[vm.activeSortBy]) > parseFloat(b[vm.activeSortBy])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            });
                        }
                    }
                }
                return ob;
            },
            picListConstruction: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'construction';
                })
            },
            picListSite: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'site';
                })
            },
            picListPresentation: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'presentation';
                })
            },
            picListAmenity: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'amenity';
                })
            },
            picListInterior: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'interior';
                })
            },
            picListProject: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'project';
                })
            },
            picListRender: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'rendering';
                })
            },
            picListConstruction: function () {
                if (this.project.pic_list == null) {
                    return [];
                }
                return this.project.pic_list.filter(function (el) {
                    return el.group == 'construction';
                })
            }
        },
        methods:{
            logout() {
                $.get(BACKEND_URL + 'api/api_logout_user', (data, status) => {
                    this.$router.push({ path: '/'});
                    this.$router.go();
                });
            },
            numberWithCommas: function(x) {
                if (x) {
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                else {
                    return x;
                }
            },
            selectedDate: function(value, propertyName) {
                this.selectedDateMap = Object.assign({}, this.selectedDateMap, {[propertyName]: {selectedDate: value}})
            },
            classStatus(status) {
                switch (status) {
                    case 'Now Selling':
                        return 'utc-now-selling-color';
                    case 'Now Leasing':
                        return 'utc-now-leasing-color';
                    case 'Selling Soon':
                        return 'utc-selling-soon-color';
                    case 'In Planning':
                        return 'utc-in-planning-color';
                    case 'Sold Out':
                    case 'Sold Out 2':
                        return 'utc-sold-out-color';
                    case 'Leasing Soon':
                        return 'utc-leasing-soon-color';
                    case 'Leased Out':
                        return 'utc-leased-out-color';
                }
            },
            activeSort(column) {
                if (this.activeSortBy == column) {
                    this.orderAsc = !this.orderAsc;
                }
                this.activeSortBy = column;
            },
            soldSort(column) {
                if (this.soldSortBy == column) {
                    this.orderAsc = !this.orderAsc;
                }
                this.soldSortBy = column;
            },
            otherSort(column) {
                if (this.otherSortBy == column) {
                    this.orderAsc = !this.orderAsc;
                }
                this.otherSortBy = column;
            },
            approveMLSEntry(cid, entry, k1, k2) {
                if (this.project.is_admin) {
                // if (true) {
                    var vm = this;
                    $.ajax({
                        type: 'POST',
                        url: 'https://www.realpropertydata.ca/backend/api/presale_mls_approve',
                        data: {cid: cid, entry: entry},
                    }).done(function(response) {
                        if (response.success) {
                            vm.project.mls_data[k1][k2].mls_need_approval = 0;
                        }
                    });
                }
            },
            editMLSEntryNew(cid, entry) {
                // if (this.project.is_admin) {
                if (true) {
                    let link = 'mls_entry_edit?cid='+cid + '&entry=' + entry +'&project='+this.$route.query.project+'&fid='+this.$route.query.fid+'&uid='+this.$route.query.uid+'&sid='+this.$route.query.sid;
                    window.open(link, '_blank');
                }
            },
            editMLSEntry(cid, entry) {
                // if (this.project.is_admin) {
                if (true) {
                    let link = 'mls_entry_edit?cid='+cid + '&entry=' + entry +'&project='+this.$route.query.project+'&fid='+this.$route.query.fid+'&uid='+this.$route.query.uid+'&sid='+this.$route.query.sid;
                    window.open(link, '_self');
                }
            },
            unApproveMLSEntry(cid, entry, k1, k2) {
                if (this.project.is_admin) {
                // if (true) {
                    var vm = this;
                    $.ajax({
                        type: 'POST',
                        url: 'https://www.realpropertydata.ca/backend/api/presale_mls_unapprove',
                        data: {cid: cid, entry: entry},
                    }).done(function(response) {
                        if (response.success) {
                            vm.project.mls_data[k1][k2].mls_need_approval = 1;
                        }
                    });
                }
            },
            deleteMLSEntry(cid, entry, k1, k2) {
                if (this.project.is_admin) {
                // if (true) {
                    if(confirm("Do you really want to delete this MLS Entry?")){
                        var vm = this;
                        $.ajax({
                            type: 'POST',
                            url: 'https://www.realpropertydata.ca/backend/api/presale_mls_entry_delete',
                            data: {cid: cid, entry: entry},
                        }).done(function(response) {
                            if (response.success) {
                                vm.project.mls_data[k1].splice(k2, 1);
                            }
                        });
                    }
                }
            },
            deleteMLS(cid) {
                if (this.project.is_admin) {
                // if (true) {
                    if(confirm("Do you really want to delete this MLS Data?")){
                        var vm = this;
                        $.ajax({
                            type: 'POST',
                            url: 'https://www.realpropertydata.ca/backend/api/presale_mls_delete',
                            data: {cid: cid},
                        }).done(function(response) {
                            if (response.success) {
                                vm.project.mls_data.splice(k, 1);
                            }
                        });
                    }
                }
            },
            uploadMLSEntry(cid) {
                if (this.project.is_admin) {
                // if (true) {
                    let link = 'mls_entry_update?cid='+cid+'&project='+this.$route.query.project+'&fid='+this.$route.query.fid+'&uid='+this.$route.query.uid+'&sid='+this.$route.query.sid;
                    window.open(link, '_blank');
                }
            },
            mlsUpload() {
                this.upload_is_loading = true
                // let data = {
                //     planName:this.uploadForm.planName,
                //     fp:this.uploadForm.fp,
                //     orientation:this.uploadForm.orientation,
                //     unit:this.uploadForm.unit,
                //     bed:this.uploadForm.bed,
                //     bath:this.uploadForm.bath,
                //     unitSize:this.uploadForm.unitSize,
                //     listPrice:this.uploadForm.listPrice,
                //     parking:this.uploadForm.parking,
                //     locker:this.uploadForm.locker,
                //     gst:this.uploadForm.gst,
                //     buyerIncentives:this.uploadForm.buyerIncentives,
                //     realtorIncentives:this.uploadForm.realtorIncentives,
                //     status:this.uploadForm.status,
                //     soldPrice:this.uploadForm.soldPrice,
                //     floorPlan:this.uploadForm.floorPlan,
                //     soldDate:this.uploadForm.soldDate,
                // };
                let formData = new FormData();
                formData.append('planName', this.uploadForm.planName);
                let fpArray = [];
                this.uploadForm.fp.forEach(
                    element => fpArray.push(element.value)
                );
                formData.append('fp', fpArray);
                formData.append('pr', this.uploadForm.pr);
                formData.append('fl', this.uploadForm.fl);
                formData.append('orientation', this.uploadForm.orientation);
                formData.append('unit', this.uploadForm.unit);
                formData.append('address', this.project.short_address);
                formData.append('bed', this.uploadForm.bed);
                formData.append('bath', this.uploadForm.bath);
                formData.append('unitSize', this.uploadForm.unitSize);
                formData.append('listPrice', this.uploadForm.listPrice);
                formData.append('parking', this.uploadForm.parking);
                formData.append('locker', this.uploadForm.locker);
                formData.append('gst', this.uploadForm.gst);
                formData.append('buyerIncentives', this.uploadForm.buyerIncentives);
                formData.append('realtorIncentives', this.uploadForm.realtorIncentives);
                formData.append('status', this.uploadForm.status);
                formData.append('soldPrice', this.uploadForm.soldPrice);
                formData.append('files', this.uploadForm.floorPlan);
                formData.append('csv', this.uploadForm.importCSV);
                formData.append('soldDate', this.uploadForm.soldDate);
                formData.append('listDate', this.uploadForm.listDate);
                formData.append('listPriceDate', this.uploadForm.listPriceDate);
                formData.append('uid', this.$route.query.uid);
                formData.append('owner', this.$route.query.owner);
                formData.append('purchaser', this.$route.query.purchaser);
                formData.append('pid', this.uploadForm.pid);
                formData.append('assignment', this.uploadForm.assignment);
                formData.append('newEntry', this.uploadForm.newEntry);
                formData.append('originalEntry', this.uploadForm.originalEntry);
                var vm = this;
                $.ajax({
					type: 'POST',
					url: 'https://www.realpropertydata.ca/backend/api/presale_mls_creation',
                    data: formData,
                    processData: false,
                    contentType: false,
				}).done(function(response) {
                    vm.upload_is_loading = false
                    vm.uploadForm = {
                        planName: '',
                        fp: [],
                        orientation: 11105,
                        unit: '',
                        bed: '',
                        bath: '',
                        unitSize: '',
                        listPrice: '',
                        pr: '',
                        locker: '',
                        gst: '',
                        buyerIncentives: '',
                        realtorIncentives: '',
                        status: 11482,
                        soldDate: null,
                        listDate: null,
                        listPriceDate: null,
                        fl: '',
                        files: null,
                        owner: '',
                        purchaser: '',
                        pid: '',
                        assignment: 0,
                        newEntry: 0,
                        originalEntry: 0
                    };
                }).always(function(){
                    vm.upload_is_loading = false
                });
            },
            projectTypeIcon(type) {
                if (type.startsWith('Apartment')) {
                    return '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.0061 19.9948C6.88731 19.9948 3.7768 19.9948 0.662134 20C0.230696 20 -0.0219286 19.7104 0.000942779 19.3374C0.0165369 19.0926 0.000942779 18.8467 0.000942779 18.6009C-0.00796501 18.4583 0.0393371 18.3179 0.132667 18.21C0.225996 18.1021 0.35789 18.0351 0.499955 18.0237C0.634065 18.0049 0.667332 17.9497 0.665253 17.8216C0.650871 17.5844 0.654694 17.3465 0.676689 17.11C0.692389 16.985 0.749484 16.869 0.838829 16.7804C0.928174 16.6918 1.0446 16.6358 1.16946 16.6214C1.30978 16.6037 1.45147 16.5995 1.59258 16.6089C1.71838 16.6162 1.7558 16.5735 1.7558 16.4464C1.75164 15.0753 1.75164 13.7043 1.7558 12.3332V2.50876C1.7558 2.35978 1.74229 2.3504 1.58947 2.35144C1.23704 2.35144 0.882531 2.37332 0.530104 2.34206C0.384851 2.33293 0.248988 2.26699 0.151767 2.15846C0.0545469 2.04992 0.00374478 1.90747 0.0102993 1.76176C0.0102993 1.37837 0.0102993 0.996367 0.0102993 0.615752C0.00407119 0.534195 0.0153393 0.452246 0.0433459 0.375416C0.0713525 0.298586 0.115449 0.228655 0.172669 0.170325C0.22989 0.111995 0.298909 0.0666179 0.375087 0.0372445C0.451264 0.00787118 0.532834 -0.00481765 0.614312 3.11468e-05H19.3522C19.7681 3.11468e-05 19.9937 0.222983 19.9968 0.638673C19.9968 0.997062 19.9968 1.35545 19.9968 1.71384C19.9968 2.09619 19.7972 2.31706 19.4198 2.34623C19.079 2.36342 18.7376 2.36342 18.3968 2.34623C18.2357 2.34623 18.2357 2.33998 18.2357 2.4973V16.437C18.2357 16.6037 18.2357 16.6026 18.3999 16.6047C18.5387 16.5998 18.6776 16.604 18.8158 16.6172C18.9588 16.6308 19.0915 16.6976 19.1878 16.8044C19.284 16.9113 19.3368 17.0504 19.3356 17.1944C19.3408 17.4225 19.3356 17.6528 19.3356 17.881C19.3356 17.9643 19.3616 18.0008 19.4468 18.0081C19.5263 18.0112 19.6042 18.0308 19.6757 18.0658C19.7472 18.1007 19.8106 18.1502 19.8619 18.2111C19.9133 18.2719 19.9514 18.3428 19.9739 18.4193C19.9964 18.4957 20.0028 18.576 19.9926 18.655C19.9791 18.8999 19.9926 19.1468 19.9926 19.3926C19.9926 19.7708 19.7712 19.9907 19.3959 19.9907H10.0061V19.9948ZM2.3411 9.68071V16.8443C2.3411 17.1048 2.23714 17.21 1.98036 17.2121C1.78075 17.2121 1.58115 17.2121 1.38154 17.2121C1.29734 17.2121 1.25991 17.2434 1.26095 17.3298C1.26095 17.5174 1.26095 17.7049 1.26095 17.8924C1.26095 17.9789 1.29422 18.0122 1.37946 18.0112C1.58739 18.0112 1.79531 18.0112 2.00323 18.0112C2.03974 18.0139 2.07628 18.0063 2.10865 17.9892C2.14102 17.972 2.1679 17.9461 2.1862 17.9143C2.35166 17.6633 2.56576 17.4482 2.81578 17.2818C3.06581 17.1153 3.34666 17.0009 3.64165 16.9454C3.73472 16.9261 3.82305 16.8886 3.90156 16.835C4.26732 16.5973 4.69671 16.477 5.13245 16.4901C5.69657 16.4988 6.23625 16.7223 6.64197 17.1152C6.66517 17.1436 6.69437 17.1664 6.72745 17.1821C6.76053 17.1978 6.79666 17.2059 6.83325 17.2059C6.86985 17.2059 6.90598 17.1978 6.93906 17.1821C6.97214 17.1664 7.00133 17.1436 7.02454 17.1152C7.38715 16.768 7.85591 16.5534 8.35518 16.5059C8.85446 16.4585 9.35513 16.581 9.77639 16.8537C9.83351 16.895 9.89814 16.9248 9.96664 16.9412C10.2757 16.9899 10.5708 17.1044 10.8321 17.2769C11.0934 17.4494 11.3147 17.676 11.4813 17.9414C11.5055 17.9842 11.5415 18.0192 11.5851 18.0419C11.6286 18.0647 11.6778 18.0743 11.7267 18.0695C12.6987 18.0539 13.6718 18.0695 14.6449 18.0497C15.802 18.0237 16.9455 18.031 18.1016 18.0237C18.2804 18.0237 18.4592 18.031 18.638 18.0122C18.7181 18.0028 18.742 17.9695 18.742 17.8924C18.742 17.7018 18.742 17.509 18.742 17.3184C18.742 17.2361 18.7087 17.2069 18.6307 17.2079C18.4311 17.2079 18.2315 17.2017 18.0319 17.2079C17.7616 17.2079 17.6483 17.1037 17.6483 16.837V6.52293C17.6483 5.17688 17.6483 3.83084 17.6483 2.48479C17.6483 2.41291 17.6597 2.35144 17.5443 2.35144C16.3342 2.35665 15.1252 2.35144 13.9151 2.35144C12.705 2.35144 11.471 2.35144 10.2494 2.35144H2.51784C2.34214 2.35144 2.3411 2.35144 2.3411 2.52334V9.68071ZM9.99159 1.76281H19.1848C19.399 1.76281 19.399 1.76281 19.4 1.54194V0.795989C19.4 0.587623 19.4 0.587623 19.1984 0.587623H0.762976C0.595599 0.587623 0.59456 0.587623 0.59456 0.750148V1.56278C0.59456 1.75239 0.59456 1.75239 0.786887 1.75239L9.99159 1.76281ZM11.3192 19.3926C11.2733 19.3082 11.2518 19.2126 11.2568 19.1166C11.2483 18.7308 11.1057 18.3601 10.8537 18.0683C10.6017 17.7766 10.256 17.5821 9.87619 17.5184C9.74079 17.4992 9.61164 17.4489 9.49881 17.3715C9.19193 17.1585 8.82175 17.0568 8.4494 17.0831C8.07704 17.1095 7.72478 17.2623 7.45078 17.5163C7.34089 17.6215 7.21119 17.7036 7.06925 17.758C6.74801 17.8778 6.48498 17.7757 6.26355 17.5632C5.66889 16.9933 4.73116 16.9173 4.10428 17.4059C4.04539 17.4563 3.97316 17.4885 3.89636 17.4986C3.53551 17.536 3.19677 17.6907 2.93175 17.939C2.66674 18.1872 2.48999 18.5155 2.42843 18.8738C2.4014 19.0332 2.44091 19.2009 2.36397 19.3531C2.34422 19.3926 2.37957 19.4041 2.41076 19.4051C2.44194 19.4062 2.48561 19.4051 2.52303 19.4051H11.0925C11.1686 19.4075 11.2448 19.4005 11.3192 19.3843V19.3926ZM15.7074 19.4156H17.64C18.1795 19.4156 18.7201 19.4156 19.2607 19.4156C19.3647 19.4156 19.4032 19.3833 19.399 19.2791C19.3928 19.1207 19.399 18.9665 19.399 18.804C19.399 18.6165 19.399 18.6144 19.214 18.6165C17.9664 18.6269 16.7127 18.6165 15.462 18.6373C14.2665 18.655 13.0709 18.654 11.8733 18.6592C11.8203 18.6592 11.7901 18.6675 11.8036 18.728C11.8462 18.9144 11.8317 19.1124 11.9668 19.2791C11.9933 19.3219 12.0304 19.3571 12.0745 19.3812C12.1186 19.4053 12.1682 19.4175 12.2184 19.4166C13.3807 19.4062 14.544 19.4072 15.7074 19.4072V19.4156ZM1.09773 19.4156C1.2308 19.4156 1.36387 19.4156 1.4959 19.4156C1.52818 19.4152 1.55992 19.4072 1.58861 19.3924C1.6173 19.3776 1.64215 19.3563 1.6612 19.3301C1.83897 19.1447 1.8213 18.903 1.86912 18.6811C1.88264 18.6165 1.84001 18.6154 1.79427 18.6154C1.43041 18.6154 1.06654 18.6154 0.7006 18.6154C0.62055 18.6154 0.590401 18.6488 0.596639 18.728C0.596639 18.9186 0.596639 19.1103 0.596639 19.301C0.596639 19.3916 0.636144 19.4166 0.717233 19.4145C0.840947 19.4051 0.969858 19.4072 1.09773 19.4072V19.4156Z" fill="black"/><path d="M6.36653 15.6661H3.81013C3.58974 15.6661 3.47226 15.5619 3.4681 15.3723C3.46629 15.3348 3.472 15.2974 3.48492 15.2621C3.49783 15.2269 3.51768 15.1946 3.54327 15.1672C3.56887 15.1398 3.5997 15.1178 3.63394 15.1026C3.66817 15.0874 3.70511 15.0792 3.74256 15.0785C3.87979 15.0785 4.01702 15.0712 4.1584 15.0785C4.26236 15.0848 4.30187 15.0483 4.30083 14.9379C4.29563 14.3795 4.30083 13.821 4.30083 13.2637C4.30083 12.9792 4.42766 12.8469 4.70836 12.8469H7.37183C7.59639 12.8469 7.81991 12.8469 8.04446 12.8469C8.30956 12.8469 8.44991 12.9876 8.45095 13.2564C8.45095 13.8023 8.45095 14.3472 8.45095 14.8931C8.45095 15.0712 8.45095 15.0723 8.62768 15.0733C8.73892 15.0733 8.8512 15.0733 8.96348 15.0733C9.00313 15.0702 9.04301 15.0752 9.08062 15.0882C9.11823 15.1013 9.15275 15.1219 9.18203 15.1489C9.2113 15.1759 9.2347 15.2086 9.25076 15.2451C9.26682 15.2816 9.2752 15.321 9.27536 15.3609C9.27608 15.4007 9.26872 15.4402 9.25372 15.4771C9.23872 15.514 9.2164 15.5474 9.1881 15.5754C9.15981 15.6034 9.12613 15.6253 9.08913 15.6398C9.05212 15.6543 9.01255 15.6611 8.97283 15.6599C8.81481 15.6661 8.66095 15.6599 8.49877 15.6599L6.36653 15.6661ZM6.37277 15.0764C6.82604 15.0764 7.27931 15.0764 7.73258 15.0764C7.8251 15.0764 7.86669 15.0546 7.86565 14.9514C7.86149 14.4888 7.86149 14.0263 7.86565 13.5637C7.86565 13.4595 7.8303 13.4345 7.73466 13.4345C6.82812 13.4345 5.92193 13.4345 5.01608 13.4345C4.91212 13.4345 4.87989 13.4731 4.88093 13.5741C4.88093 14.0284 4.88093 14.4826 4.88093 14.9368C4.88093 15.0494 4.9194 15.0775 5.02544 15.0764C5.47455 15.0744 5.92574 15.0764 6.37277 15.0764Z" fill="black"/><path d="M13.6193 6.21872C12.7599 6.21872 11.8994 6.21872 11.0379 6.21872C10.83 6.21872 10.726 6.10516 10.7343 5.90617C10.7352 5.84311 10.7582 5.78236 10.7992 5.73455C10.8403 5.68675 10.8968 5.65493 10.9589 5.64467C11.0991 5.62558 11.2408 5.62 11.382 5.628C11.5556 5.628 11.5567 5.628 11.5567 5.45818C11.5567 4.9081 11.5567 4.35801 11.5567 3.80897C11.5567 3.54955 11.696 3.40161 11.9538 3.40057C13.0766 3.40057 14.199 3.40057 15.3211 3.40057C15.3745 3.3968 15.4281 3.40477 15.478 3.42393C15.528 3.44309 15.5732 3.47298 15.6105 3.51149C15.6477 3.55 15.6761 3.59621 15.6936 3.64688C15.7112 3.69755 15.7174 3.75145 15.712 3.8048C15.712 4.35905 15.712 4.91227 15.712 5.46652C15.712 5.59258 15.7474 5.63634 15.8742 5.63113C16.0127 5.61716 16.1523 5.62031 16.29 5.6405C16.364 5.65063 16.4313 5.68856 16.4784 5.74659C16.5255 5.80462 16.5489 5.87843 16.5437 5.95305C16.5356 6.02634 16.5001 6.09384 16.4444 6.14197C16.3886 6.1901 16.3168 6.21529 16.2433 6.21247C15.973 6.21247 15.7027 6.21247 15.4324 6.21247L13.6193 6.21872ZM13.6463 3.99545C13.1972 3.99545 12.7481 3.99545 12.2948 3.99545C12.1784 3.99545 12.1357 4.02358 12.1368 4.14756C12.1441 4.5893 12.1368 5.03103 12.1368 5.47277C12.1368 5.6353 12.1368 5.63634 12.3073 5.63634H14.0528C14.3647 5.63634 14.6849 5.63634 15.0009 5.63634C15.0726 5.63634 15.1184 5.62175 15.1184 5.53215C15.1184 5.05291 15.1184 4.57367 15.1184 4.09443C15.1184 4.02879 15.0966 3.99754 15.0238 3.99754C14.5684 3.9965 14.1079 3.99545 13.6463 3.99545Z" fill="black"/><path d="M13.5621 15.6659H11.0193C10.9271 15.6749 10.835 15.6476 10.7625 15.5899C10.7169 15.5525 10.6841 15.5018 10.6684 15.4449C10.6528 15.388 10.6551 15.3276 10.6751 15.2721C10.6899 15.2171 10.7221 15.1684 10.7669 15.1334C10.8118 15.0985 10.8668 15.0791 10.9236 15.0783C11.0621 15.0704 11.201 15.0704 11.3395 15.0783C11.4528 15.0856 11.4902 15.0481 11.4892 14.9314C11.4892 14.3855 11.4892 13.8406 11.4892 13.2947C11.4892 12.9707 11.6108 12.8499 11.9331 12.8499H15.238C15.5249 12.8499 15.6455 12.9717 15.6466 13.2666C15.6466 13.824 15.6466 14.3824 15.6466 14.9408C15.6466 15.045 15.6777 15.0898 15.7879 15.0825C15.8981 15.0752 16.0374 15.0825 16.1622 15.0825C16.2019 15.0774 16.2422 15.0809 16.2804 15.0929C16.3186 15.1049 16.3538 15.1251 16.3834 15.152C16.4131 15.179 16.4365 15.2121 16.4522 15.249C16.4678 15.2859 16.4753 15.3258 16.4741 15.3659C16.4765 15.4072 16.47 15.4485 16.455 15.4871C16.4401 15.5256 16.417 15.5605 16.3874 15.5893C16.3579 15.6182 16.3225 15.6403 16.2836 15.6543C16.2447 15.6682 16.2033 15.6736 16.1622 15.6701C15.9792 15.6701 15.7963 15.6701 15.6133 15.6701L13.5621 15.6659ZM13.5538 15.0763C14.0113 15.0763 14.4687 15.0763 14.9261 15.0763C15.0124 15.0763 15.054 15.0565 15.054 14.9585C15.0498 14.4918 15.0498 14.0254 15.054 13.5593C15.054 13.4656 15.0207 13.4354 14.9303 13.4354C14.0196 13.4354 13.1089 13.4354 12.1982 13.4354C12.0942 13.4354 12.0703 13.4718 12.0713 13.5677C12.0713 14.0261 12.0713 14.4845 12.0713 14.9429C12.0713 15.0471 12.1077 15.0783 12.2086 15.0773C12.6556 15.0742 13.1047 15.0763 13.5538 15.0763Z" fill="black"/><path d="M6.37008 10.9392H3.80016C3.63486 10.9392 3.53818 10.8808 3.48828 10.7579C3.4659 10.7014 3.46087 10.6395 3.47383 10.5801C3.4868 10.5207 3.51717 10.4665 3.56105 10.4245C3.58859 10.3982 3.62131 10.3779 3.65711 10.365C3.69292 10.3521 3.73102 10.3468 3.76897 10.3495C3.89788 10.3495 4.0268 10.3433 4.15467 10.3495C4.25863 10.3558 4.30125 10.3235 4.30021 10.2099C4.29502 9.66502 4.30021 9.1191 4.30021 8.57318C4.30021 8.24084 4.41561 8.12207 4.74725 8.12207H8.02201C8.31311 8.12207 8.45241 8.25959 8.45241 8.54818C8.45241 9.0941 8.45241 9.64002 8.45241 10.1859C8.45241 10.3485 8.45241 10.3485 8.61979 10.3485H8.93167C9.13959 10.3485 9.27266 10.4641 9.2737 10.6454C9.27474 10.8267 9.14167 10.9392 8.92751 10.9392H6.37008ZM6.38047 8.71175C5.93136 8.71175 5.48225 8.71175 5.02898 8.71175C4.91774 8.71175 4.87512 8.73883 4.8772 8.85864C4.88343 9.30351 4.8772 9.74941 4.8772 10.1953C4.8772 10.312 4.90631 10.3537 5.03002 10.3537C5.91992 10.3481 6.80948 10.3481 7.6987 10.3537C7.82137 10.3537 7.86503 10.3245 7.86295 10.1943C7.85568 9.75253 7.85672 9.3108 7.86295 8.86906C7.86295 8.75134 7.83281 8.70966 7.71013 8.7107C7.26934 8.71904 6.82438 8.71487 6.38047 8.71487V8.71175Z" fill="black"/><path d="M6.37177 6.22183H3.79042C3.59081 6.22183 3.47854 6.12598 3.47126 5.95095C3.46703 5.91038 3.47158 5.86937 3.48462 5.83072C3.49766 5.79208 3.51887 5.75671 3.54681 5.72703C3.57474 5.69736 3.60874 5.67408 3.64648 5.65878C3.68421 5.64348 3.7248 5.63653 3.76547 5.6384C3.88191 5.62903 3.99834 5.6384 4.11478 5.6384C4.29567 5.6384 4.29567 5.6384 4.29567 5.46234V3.81937C4.29567 3.55371 4.43498 3.40264 4.698 3.40264C5.81593 3.40264 6.93385 3.40264 8.05178 3.40264C8.10645 3.39972 8.16112 3.40863 8.21205 3.42876C8.26299 3.44889 8.30901 3.47977 8.34698 3.5193C8.38495 3.55884 8.41398 3.6061 8.43211 3.65787C8.45024 3.70965 8.45703 3.76473 8.45203 3.81937C8.45203 4.36946 8.45203 4.9185 8.45203 5.46859C8.45203 5.63215 8.45203 5.63007 8.62044 5.6332C8.7617 5.62344 8.90361 5.62938 9.04357 5.65091C9.09939 5.66069 9.15086 5.68742 9.19103 5.72748C9.23119 5.76754 9.2581 5.819 9.26812 5.8749C9.28023 5.93039 9.27529 5.98826 9.25395 6.04089C9.23261 6.09352 9.19587 6.13844 9.14857 6.16974C9.10122 6.20482 9.04309 6.22215 8.98431 6.2187H6.37177V6.22183ZM6.37177 3.99336C5.9185 3.99336 5.46523 3.99336 5.013 3.99336C4.90904 3.99336 4.88409 4.02774 4.88409 4.12359C4.88825 4.58199 4.88825 5.04005 4.88409 5.49776C4.88409 5.60194 4.91736 5.63632 5.02132 5.63528C5.92647 5.63528 6.83232 5.63528 7.73886 5.63528C7.8345 5.63528 7.86985 5.60402 7.86881 5.50609C7.86881 5.05186 7.86881 4.59762 7.86881 4.14442C7.86881 4.0267 7.82514 3.99336 7.71494 3.9944C7.26583 3.99648 6.81672 3.99336 6.36865 3.99336H6.37177Z" fill="black"/><path d="M13.554 10.9392H11.0111C10.8749 10.9392 10.7533 10.91 10.6899 10.7714C10.6688 10.7275 10.659 10.6791 10.6615 10.6304C10.664 10.5818 10.6787 10.5345 10.7041 10.493C10.7296 10.4516 10.765 10.4171 10.8072 10.393C10.8494 10.3688 10.897 10.3556 10.9456 10.3547C11.0841 10.3473 11.2229 10.3473 11.3614 10.3547C11.4654 10.3547 11.4893 10.3182 11.4883 10.2234C11.4883 9.67334 11.4883 9.12325 11.4883 8.57317C11.4883 8.26062 11.6193 8.12622 11.9343 8.12622H15.2132C15.5251 8.12622 15.6446 8.24916 15.6446 8.5565C15.6446 9.10658 15.6446 9.65667 15.6446 10.2057C15.6446 10.3203 15.6758 10.363 15.7923 10.3547C15.9087 10.3464 16.0418 10.3547 16.1665 10.3547C16.2049 10.3522 16.2435 10.3574 16.2798 10.3703C16.3162 10.3831 16.3495 10.4031 16.3779 10.4292C16.4063 10.4553 16.4291 10.4869 16.4449 10.5221C16.4608 10.5573 16.4693 10.5953 16.4701 10.6339C16.4737 10.6736 16.4687 10.7137 16.4556 10.7514C16.4425 10.7891 16.4215 10.8235 16.3941 10.8524C16.3666 10.8813 16.3333 10.904 16.2964 10.919C16.2595 10.9339 16.2198 10.9408 16.18 10.9392C16.0345 10.9465 15.8889 10.9392 15.7434 10.9392H13.554ZM13.554 10.3484C14.0062 10.3484 14.4595 10.3484 14.9117 10.3484C15.0157 10.3484 15.0531 10.3224 15.0521 10.2151C15.0469 9.75773 15.0521 9.29932 15.0521 8.84196C15.0521 8.74819 15.0281 8.70756 14.9263 8.70756C14.0169 8.70756 13.1069 8.70756 12.1962 8.70756C12.0923 8.70756 12.0684 8.74298 12.0694 8.83883C12.0694 9.29307 12.0694 9.74731 12.0694 10.2005C12.0694 10.3193 12.111 10.3495 12.2222 10.3484C12.6662 10.3484 13.1111 10.3516 13.5561 10.3516L13.554 10.3484Z" fill="black"/></svg>';
                }
                else if (type.startsWith('Mixed-Use Apartment')) {
                    return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.6667 7.48071L19.0084 8.9501C19.6001 9.07605 20.0001 9.57984 20.0001 10.176V18.7404C20.0001 19.4373 19.4418 19.9999 18.7501 19.9999H11.25C11.4833 19.9999 11.6667 19.8152 11.6667 19.5801V19.1602H18.7501C18.9751 19.1602 19.1668 18.9755 19.1668 18.7404V10.176C19.1668 9.98287 19.0334 9.80654 18.8418 9.76456L11.6667 8.33716V7.48071Z" fill="black"/>
                        <path d="M16.2494 11.6035C16.4827 11.6035 16.666 11.7882 16.666 12.0233C16.666 12.2584 16.4827 12.4432 16.2494 12.4432H14.5827C14.3494 12.4432 14.166 12.2584 14.166 12.0233C14.166 11.7882 14.3494 11.6035 14.5827 11.6035H16.2494Z" fill="black"/>
                        <path d="M16.2494 14.1226C16.4827 14.1226 16.666 14.3073 16.666 14.5424C16.666 14.7775 16.4827 14.9622 16.2494 14.9622H14.5827C14.3494 14.9622 14.166 14.7775 14.166 14.5424C14.166 14.3073 14.3494 14.1226 14.5827 14.1226H16.2494Z" fill="black"/>
                        <path d="M16.2494 16.6414C16.4827 16.6414 16.666 16.8261 16.666 17.0612C16.666 17.2963 16.4827 17.481 16.2494 17.481H14.5827C14.3494 17.481 14.166 17.2963 14.166 17.0612C14.166 16.8261 14.3494 16.6414 14.5827 16.6414H16.2494Z" fill="black"/>
                        <path d="M11.6663 19.58C11.6663 19.8151 11.483 19.9999 11.2497 19.9999C11.0163 19.9999 10.833 19.8151 10.833 19.58V19.1602V7.82497C10.833 7.69902 10.8913 7.58147 10.983 7.49751C11.083 7.42194 11.208 7.38835 11.333 7.41354L11.6663 7.48072V8.33716V19.1602V19.58Z" fill="black"/>
                        <path d="M10.8327 19.1604V19.5802C10.8327 19.8153 11.016 20 11.2494 20H7.91602C8.14935 20 8.33269 19.8153 8.33269 19.5802V19.1604H10.8327Z" fill="black"/>
                        <path d="M8.74937 4.04663C8.98271 4.04663 9.16605 4.23135 9.16605 4.46646C9.16605 4.70156 8.98271 4.88628 8.74937 4.88628H7.08269C6.84935 4.88628 6.66602 4.70156 6.66602 4.46646C6.66602 4.23135 6.84935 4.04663 7.08269 4.04663H8.74937Z" fill="black"/>
                        <path d="M9.16605 6.9855C9.16605 7.2206 8.98271 7.40532 8.74937 7.40532H7.08269C6.84935 7.40532 6.66602 7.2206 6.66602 6.9855C6.66602 6.7504 6.84935 6.56567 7.08269 6.56567H8.74937C8.98271 6.56567 9.16605 6.7504 9.16605 6.9855Z" fill="black"/>
                        <path d="M8.74937 9.08447C8.98271 9.08447 9.16605 9.2692 9.16605 9.5043C9.16605 9.7394 8.98271 9.92412 8.74937 9.92412H7.08269C6.84935 9.92412 6.66602 9.7394 6.66602 9.5043C6.66602 9.2692 6.84935 9.08447 7.08269 9.08447H8.74937Z" fill="black"/>
                        <path d="M8.74937 11.6035C8.98271 11.6035 9.16605 11.7882 9.16605 12.0233C9.16605 12.2584 8.98271 12.4432 8.74937 12.4432H7.08269C6.84935 12.4432 6.66602 12.2584 6.66602 12.0233C6.66602 11.7882 6.84935 11.6035 7.08269 11.6035H8.74937Z" fill="black"/>
                        <path d="M5.00003 12.0233C5.00003 12.2584 4.81669 12.4432 4.58336 12.4432H2.91667C2.68334 12.4432 2.5 12.2584 2.5 12.0233C2.5 11.7882 2.68334 11.6035 2.91667 11.6035H4.58336C4.81669 11.6035 5.00003 11.7882 5.00003 12.0233Z" fill="black"/>
                        <path d="M4.58336 4.04663C4.81669 4.04663 5.00003 4.23135 5.00003 4.46646C5.00003 4.70156 4.81669 4.88628 4.58336 4.88628H2.91667C2.68334 4.88628 2.5 4.70156 2.5 4.46646C2.5 4.23135 2.68334 4.04663 2.91667 4.04663H4.58336Z" fill="black"/>
                        <path d="M4.58336 6.56567C4.81669 6.56567 5.00003 6.7504 5.00003 6.9855C5.00003 7.2206 4.81669 7.40532 4.58336 7.40532H2.91667C2.68334 7.40532 2.5 7.2206 2.5 6.9855C2.5 6.7504 2.68334 6.56567 2.91667 6.56567H4.58336Z" fill="black"/>
                        <path d="M4.58336 9.08447C4.81669 9.08447 5.00003 9.2692 5.00003 9.5043C5.00003 9.7394 4.81669 9.92412 4.58336 9.92412H2.91667C2.68334 9.92412 2.5 9.7394 2.5 9.5043C2.5 9.2692 2.68334 9.08447 2.91667 9.08447H4.58336Z" fill="black"/>
                        <path d="M7.49972 15.382C7.49972 15.1469 7.30806 14.9622 7.08305 14.9622H4.58302C4.34969 14.9622 4.16635 15.1469 4.16635 15.382V19.1605H3.33301V15.382C3.33301 14.6851 3.89135 14.1226 4.58302 14.1226H7.08305C7.77473 14.1226 8.33307 14.6851 8.33307 15.382V19.1605H7.49972V15.382Z" fill="black"/>
                        <path d="M4.16635 19.1604H7.49972H8.33307V19.5802C8.33307 19.8153 8.14973 20 7.9164 20H3.74968C3.51634 20 3.33301 19.8153 3.33301 19.5802V19.1604H4.16635Z" fill="black"/>
                        <path d="M1.45835 0.0163471L10.6168 1.41856C11.2251 1.51932 11.6668 2.0399 11.6668 2.66124V7.48082L11.3335 7.41365C11.2085 7.38846 11.0835 7.42205 10.9835 7.49762C10.8918 7.58158 10.8335 7.69913 10.8335 7.82508V2.66124C10.8335 2.45133 10.6835 2.275 10.4835 2.24142L1.32502 0.8476C1.30002 0.839203 1.27502 0.839203 1.25002 0.839203C1.15001 0.839203 1.05835 0.872789 0.983345 0.939961C0.883344 1.02393 0.833343 1.13308 0.833343 1.25903V18.7405C0.833343 18.9756 1.02501 19.1603 1.25002 19.1603H3.33337V19.5802C3.33337 19.8153 3.51671 20 3.75005 20H1.25002C0.55834 20 0 19.4374 0 18.7405V1.25903C0 0.889582 0.158335 0.536929 0.441672 0.301828C0.725009 0.0583296 1.09168 -0.0424283 1.45835 0.0163471Z" fill="black"/>
                        </svg>`;
                }
                else if (type.startsWith('Townhome')) {
                    return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.6875 13.1251L18.3813 6.56256H17.1875V4.63412L17.8916 5.13693C18.0516 5.25193 18.2403 5.31256 18.4372 5.31256C18.7394 5.31256 19.0247 5.16568 19.2003 4.91975C19.346 4.716 19.4035 4.46756 19.3622 4.22037C19.3207 3.97287 19.1857 3.75693 18.9822 3.61256L14.6069 0.486934C14.2869 0.258809 13.8369 0.258809 13.5178 0.487559L9.14347 3.61193C8.9394 3.75693 8.8044 3.97318 8.76284 4.22037C8.72159 4.46756 8.77878 4.716 8.92503 4.92037C9.21503 5.32537 9.82722 5.42725 10.2325 5.13756L10.9375 4.63381V6.56256H7.93409L7.49878 6.17568C7.15472 5.86881 6.59503 5.86943 6.25222 6.17506L0.627528 11.1744C0.440028 11.3407 0.328778 11.5701 0.314091 11.8201C0.299716 12.0704 0.383153 12.311 0.549091 12.4976C0.726903 12.6982 0.982528 12.8132 1.25003 12.8132C1.47972 12.8132 1.70097 12.7288 1.87315 12.5757L2.18753 12.2963V19.6876H19.0625V15.3126H19.6875V13.1251ZM17.8688 7.18756L19.0625 13.156V13.4376H11.5625V12.2963L11.8769 12.5757C12.2488 12.9066 12.8703 12.8694 13.2007 12.4982C13.3669 12.311 13.4503 12.0704 13.4357 11.8201C13.421 11.5697 13.3097 11.3407 13.1228 11.1751L11.8013 10.0001H17.1875V7.18756H17.8688ZM14.6875 9.37506H13.4375V6.87506H14.6875V9.37506ZM9.86909 4.62912C9.73347 4.72568 9.5294 4.691 9.43315 4.55693C9.3844 4.48881 9.36534 4.406 9.37909 4.3235C9.39315 4.23975 9.4369 4.17006 9.50597 4.12068L13.881 0.995996C13.9878 0.919746 14.1375 0.920371 14.2438 0.995684L18.6191 4.12162C18.6866 4.16943 18.7316 4.24131 18.7453 4.3235C18.7591 4.406 18.74 4.4885 18.6916 4.55631C18.595 4.69193 18.3919 4.72693 18.255 4.62881L14.0625 1.63412L9.86909 4.62912ZM14.0625 2.40193L16.5625 4.18787V9.37506H15.3125V6.25006H12.8125V9.37506H11.5625V4.18756L14.0625 2.40193ZM10.9375 7.18756V9.23225L8.63722 7.18756H10.9375ZM1.45784 12.1088C1.33315 12.2197 1.12722 12.2069 1.01628 12.0826C0.960966 12.0207 0.933153 11.9404 0.938153 11.8566C0.943153 11.7732 0.980028 11.6969 1.04253 11.6416L6.66753 6.64162C6.72503 6.59068 6.79847 6.56256 6.87503 6.56256C6.95159 6.56256 7.02534 6.59068 7.08315 6.64225L12.7082 11.6422C12.7703 11.6976 12.8072 11.7735 12.8119 11.8569C12.8169 11.9416 12.7897 12.0197 12.7335 12.0835C12.6235 12.2072 12.4166 12.2197 12.2922 12.1091L6.87503 7.2935L1.45784 12.1088ZM6.87503 8.12975L10.9375 11.7407V12.8126H8.43753V10.3126H5.31253V12.8126H2.81253V11.7407L6.87503 8.12975ZM7.81253 12.8126H5.93753V10.9376H7.81253V12.8126ZM2.81253 13.4376H10.9375V19.0626H7.18753V15.3126H3.43753V19.0626H2.81253V13.4376ZM6.56253 19.0626H4.06253V15.9376H6.56253V19.0626ZM18.4375 19.0626H11.5625V15.3126H18.4375V19.0626ZM11.5625 14.6876V14.0626H19.0625V14.6876H11.5625Z" fill="black"/>
                        <path d="M10.3125 14.0625H7.8125V16.5625H10.3125V14.0625ZM9.6875 15.9375H8.4375V14.6875H9.6875V15.9375Z" fill="black"/>
                        <path d="M14.6875 18.4375V15.9375H12.1875V18.4375H14.6875ZM12.8125 16.5625H14.0625V17.8125H12.8125V16.5625Z" fill="black"/>
                        <path d="M17.8125 15.9375H15.3125V18.4375H17.8125V15.9375ZM17.1875 17.8125H15.9375V16.5625H17.1875V17.8125Z" fill="black"/>
                        </svg>`;
                }
                else if (type.startsWith('Stacked Townhome')) {
                    return `<svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.33333 17.6666C7.51742 17.6666 7.66667 17.5173 7.66667 17.3333V16.6666C7.66667 16.4825 7.51742 16.3333 7.33333 16.3333C7.14925 16.3333 7 16.4825 7 16.6666V17.3333C7 17.5173 7.14925 17.6666 7.33333 17.6666Z" fill="black"/>
                        <path d="M15.6667 8H14.6667V2.66667H15.6667C15.8508 2.66654 15.9999 2.51717 15.9998 2.33308C15.9997 2.29737 15.994 2.26188 15.9827 2.228L15.316 0.228C15.2707 0.0919167 15.1434 0.000125 15 0H1C0.856583 0.000125 0.729333 0.0919167 0.684 0.228L0.0173333 2.228C-0.0408333 2.40267 0.0535834 2.59142 0.22825 2.64958C0.262125 2.66088 0.297625 2.66663 0.333333 2.66667H1.33333V8H0.333333C0.14925 8 0 8.14925 0 8.33333V9.66667C0 9.85075 0.14925 10 0.333333 10H1.33333V19.6667C1.33333 19.8507 1.48258 20 1.66667 20H14.3333C14.5174 20 14.6667 19.8507 14.6667 19.6667V10H15.6667C15.8508 10 16 9.85075 16 9.66667V8.33333C16 8.14925 15.8508 8 15.6667 8ZM0.796 2L1.24033 0.666667H14.7597L15.204 2H0.796ZM14 2.66667V8H2V2.66667H14ZM9.33333 19.3333H6.66667V15.3333H9.33333V19.3333ZM14 19.3333H10V15C10 14.8159 9.85075 14.6667 9.66667 14.6667H6.33333C6.14925 14.6667 6 14.8159 6 15V19.3333H2V10H14V19.3333ZM15.3333 9.33333H0.666667V8.66667H15.3333V9.33333Z" fill="black"/>
                        <path d="M3.66683 6.66667H5.66683C5.85091 6.66667 6.00016 6.51742 6.00016 6.33333V4.33333C6.00016 4.14925 5.85091 4 5.66683 4H3.66683C3.48275 4 3.3335 4.14925 3.3335 4.33333V6.33333C3.3335 6.51742 3.48275 6.66667 3.66683 6.66667ZM4.00016 4.66667H5.3335V6H4.00016V4.66667Z" fill="black"/>
                        <path d="M10.3333 6.66667H12.3333C12.5174 6.66667 12.6667 6.51742 12.6667 6.33333V4.33333C12.6667 4.14925 12.5174 4 12.3333 4H10.3333C10.1493 4 10 4.14925 10 4.33333V6.33333C10 6.51742 10.1493 6.66667 10.3333 6.66667ZM10.6667 4.66667H12V6H10.6667V4.66667Z" fill="black"/>
                        <path d="M3.66683 13.9999H5.66683C5.85091 13.9999 6.00016 13.8507 6.00016 13.6666V11.6666C6.00016 11.4825 5.85091 11.3333 5.66683 11.3333H3.66683C3.48275 11.3333 3.3335 11.4825 3.3335 11.6666V13.6666C3.3335 13.8507 3.48275 13.9999 3.66683 13.9999ZM4.00016 11.9999H5.3335V13.3333H4.00016V11.9999Z" fill="black"/>
                        <path d="M10.3333 13.9999H12.3333C12.5174 13.9999 12.6667 13.8507 12.6667 13.6666V11.6666C12.6667 11.4825 12.5174 11.3333 12.3333 11.3333H10.3333C10.1493 11.3333 10 11.4825 10 11.6666V13.6666C10 13.8507 10.1493 13.9999 10.3333 13.9999ZM10.6667 11.9999H12V13.3333H10.6667V11.9999Z" fill="black"/>
                        </svg>`;
                }
                else if (type.startsWith('Commercial')) {
                    return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.619048 19.4091H7.95238V5.42541L0.619048 8.2871V19.4091ZM8.14908 5.34865C8.14915 5.34862 8.14922 5.34859 8.1493 5.34856L8.09524 5.22234L8.1493 5.34856L8.14908 5.34865ZM0 19.5455V8.19553C0 8.01092 0.116974 7.84464 0.295994 7.77478L7.91504 4.8016C8.2283 4.67935 8.57143 4.89929 8.57143 5.22234V19.5455C8.57143 19.7965 8.35823 20 8.09524 20H0.476191C0.213198 20 0 19.7965 0 19.5455Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0951 0.590909V19.4091H19.3808V0.590909H11.0951ZM10.9523 0C10.6893 0 10.4761 0.203507 10.4761 0.454545V19.5455C10.4761 19.7965 10.6893 20 10.9523 20H19.5237C19.7867 20 19.9999 19.7965 19.9999 19.5455V0.454546C19.9999 0.203507 19.7867 0 19.5237 0H10.9523Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 5.81823H12.7618V6.90914H13.9047V5.81823ZM12.3809 5.45459V7.27277H14.2856V5.45459H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 2.18175H12.7618V3.27266H13.9047V2.18175ZM12.3809 1.81812V3.6363H14.2856V1.81812H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 9.45446H12.7618V10.5454H13.9047V9.45446ZM12.3809 9.09082V10.909H14.2856V9.09082H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 13.0909H12.7618V14.1818H13.9047V13.0909ZM12.3809 12.7273V14.5455H14.2856V12.7273H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9047 16.7272H12.7618V17.8181H13.9047V16.7272ZM12.3809 16.3635V18.1817H14.2856V16.3635H12.3809Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28553 16.7272H5.14267V17.8181H6.28553V16.7272ZM4.76172 16.3635V18.1817H6.66648V16.3635H4.76172Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42811 16.7272H2.28525V17.8181H3.42811V16.7272ZM1.9043 16.3635V18.1817H3.80906V16.3635H1.9043Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28553 13.0909H5.14267V14.1818H6.28553V13.0909ZM4.76172 12.7273V14.5455H6.66648V12.7273H4.76172Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42811 13.0909H2.28525V14.1818H3.42811V13.0909ZM1.9043 12.7273V14.5455H3.80906V12.7273H1.9043Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28553 9.45446H5.14267V10.5454H6.28553V9.45446ZM4.76172 9.09082V10.909H6.66648V9.09082H4.76172Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42811 9.45446H2.28525V10.5454H3.42811V9.45446ZM1.9043 9.09082V10.909H3.80906V9.09082H1.9043Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 5.81823H16.5714V6.90914H17.7142V5.81823ZM16.1904 5.45459V7.27277H18.0952V5.45459H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 2.18175H16.5714V3.27266H17.7142V2.18175ZM16.1904 1.81812V3.6363H18.0952V1.81812H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 9.45446H16.5714V10.5454H17.7142V9.45446ZM16.1904 9.09082V10.909H18.0952V9.09082H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 13.0909H16.5714V14.1818H17.7142V13.0909ZM16.1904 12.7273V14.5455H18.0952V12.7273H16.1904Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7142 16.7272H16.5714V17.8181H17.7142V16.7272ZM16.1904 16.3635V18.1817H18.0952V16.3635H16.1904Z" fill="black"/>
                        </svg>`;
                }
                else {
                    return `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.0037 7.23897C15.0003 7.16645 14.9682 7.09828 14.9144 7.04945C14.8607 7.00061 14.7898 6.97512 14.7172 6.97858C14.6447 6.98204 14.5766 7.01417 14.5277 7.0679C14.4789 7.12162 14.4534 7.19255 14.4569 7.26507L14.4995 8.1571C14.5028 8.22725 14.5331 8.29343 14.5839 8.3419C14.6347 8.39037 14.7023 8.41741 14.7725 8.41741H14.7856C14.8216 8.41587 14.857 8.40722 14.8896 8.39197C14.9223 8.37673 14.9516 8.35517 14.9759 8.32856C15.0002 8.30194 15.0189 8.27079 15.0312 8.23688C15.0434 8.20298 15.0488 8.167 15.047 8.131L15.0037 7.23897Z" fill="black"/>
                        <path d="M15.5664 1.67969C15.2454 1.68006 14.9376 1.80776 14.7106 2.03477C14.4835 2.26179 14.3558 2.56958 14.3555 2.89062C14.3555 2.96315 14.3843 3.03269 14.4356 3.08397C14.4868 3.13525 14.5564 3.16406 14.6289 3.16406C14.7014 3.16406 14.771 3.13525 14.8223 3.08397C14.8735 3.03269 14.9023 2.96315 14.9023 2.89062C14.9026 2.71457 14.9726 2.54578 15.0971 2.42129C15.2216 2.2968 15.3903 2.22677 15.5664 2.22656H16.3906C16.4631 2.22656 16.5327 2.19775 16.584 2.14647C16.6353 2.0952 16.6641 2.02565 16.6641 1.95312C16.6641 1.8806 16.6353 1.81105 16.584 1.75978C16.5327 1.7085 16.4631 1.67969 16.3906 1.67969H15.5664Z" fill="black"/>
                        <path d="M18.9841 1.67969H17.543C17.4704 1.67969 17.4009 1.7085 17.3496 1.75978C17.2983 1.81105 17.2695 1.8806 17.2695 1.95312C17.2695 2.02565 17.2983 2.0952 17.3496 2.14647C17.4009 2.19775 17.4704 2.22656 17.543 2.22656H18.9841C19.0566 2.22656 19.1261 2.19775 19.1774 2.14647C19.2287 2.0952 19.2575 2.02565 19.2575 1.95312C19.2575 1.8806 19.2287 1.81105 19.1774 1.75978C19.1261 1.7085 19.0566 1.67969 18.9841 1.67969Z" fill="black"/>
                        <path d="M18.6074 1.28906H18.984C19.0565 1.28906 19.1261 1.26025 19.1773 1.20897C19.2286 1.1577 19.2574 1.08815 19.2574 1.01562C19.2574 0.943105 19.2286 0.873555 19.1773 0.822276C19.1261 0.770996 19.0565 0.742188 18.984 0.742188H18.6074C18.5349 0.742188 18.4654 0.770996 18.4141 0.822276C18.3628 0.873555 18.334 0.943105 18.334 1.01562C18.334 1.08815 18.3628 1.1577 18.4141 1.20897C18.4654 1.26025 18.5349 1.28906 18.6074 1.28906Z" fill="black"/>
                        <path d="M13.6914 3.16406C13.7639 3.16406 13.8335 3.13525 13.8848 3.08397C13.936 3.0327 13.9648 2.96315 13.9648 2.89062C13.9653 2.466 14.1342 2.0589 14.4344 1.75865C14.7347 1.4584 15.1418 1.28952 15.5664 1.28906H17.1039C17.1764 1.28906 17.246 1.26025 17.2973 1.20897C17.3485 1.1577 17.3773 1.08815 17.3773 1.01562C17.3773 0.943105 17.3485 0.873555 17.2973 0.822276C17.246 0.770996 17.1764 0.742188 17.1039 0.742188H15.5664C14.9968 0.742808 14.4507 0.96936 14.0479 1.37214C13.6451 1.77491 13.4186 2.32101 13.418 2.89062C13.418 2.96315 13.4468 3.0327 13.4981 3.08397C13.5493 3.13525 13.6189 3.16406 13.6914 3.16406Z" fill="black"/>
                        <path d="M18.9844 17.7733H18.3203V11.8265C18.3203 11.754 18.2915 11.6844 18.2402 11.6331C18.1889 11.5818 18.1194 11.553 18.0469 11.553H16.1481L15.8341 4.9668C15.8823 4.94525 15.9234 4.91017 15.9521 4.8658C15.9809 4.82143 15.9961 4.76967 15.9961 4.7168V3.7793C15.9961 3.70678 15.9673 3.63723 15.916 3.58595C15.8647 3.53467 15.7952 3.50586 15.7227 3.50586H12.5977C12.5251 3.50586 12.4556 3.53467 12.4043 3.58595C12.353 3.63723 12.3242 3.70678 12.3242 3.7793V4.7168C12.3242 4.76967 12.3394 4.82143 12.3682 4.8658C12.397 4.91017 12.438 4.94525 12.4862 4.9668L12.1719 11.553H8.44688V10.2734H9.11062C9.18313 10.2733 9.25266 10.2445 9.30393 10.1932C9.3552 10.1419 9.38402 10.0724 9.38406 9.99992V9.06242C9.38402 8.98991 9.3552 8.92038 9.30393 8.86911C9.25266 8.81784 9.18313 8.78902 9.11062 8.78898H1.01562C0.943118 8.78902 0.873592 8.81784 0.822321 8.86911C0.771051 8.92038 0.742229 8.98991 0.742188 9.06242V9.99992C0.742229 10.0724 0.771051 10.1419 0.822321 10.1932C0.873592 10.2445 0.943118 10.2733 1.01562 10.2734H1.67969V17.7733H1.01562C0.943118 17.7734 0.873592 17.8022 0.822321 17.8535C0.771051 17.9048 0.742229 17.9743 0.742188 18.0468V18.9843C0.742229 19.0568 0.771051 19.1263 0.822321 19.1776C0.873592 19.2289 0.943118 19.2577 1.01562 19.2577H18.9844C19.0569 19.2577 19.1264 19.2289 19.1777 19.1776C19.229 19.1264 19.2578 19.0568 19.2578 18.9843V18.0468C19.2578 17.9743 19.229 17.9047 19.1777 17.8534C19.1264 17.8022 19.0569 17.7733 18.9844 17.7733ZM12.8711 4.05336H15.4492V4.44398H12.8711V4.05336ZM13.0327 4.99086H15.2877L15.6002 11.5534H12.7197L13.0327 4.99086ZM17.7734 12.1002V17.7737H8.44688V12.0999L17.7734 12.1002ZM1.28906 9.33585H8.83719V9.72648H1.28906V9.33585ZM2.22656 10.2734H7.9V17.7733H6.27406V14.9218C6.27402 14.8493 6.2452 14.7798 6.19393 14.7285C6.14266 14.6772 6.07313 14.6484 6.00062 14.6483H4.12562C4.0531 14.6483 3.98355 14.6772 3.93228 14.7284C3.881 14.7797 3.85219 14.8493 3.85219 14.9218V17.7733H2.22656V10.2734ZM5.72656 17.7733H4.39844V15.1952H5.72656V17.7733ZM18.7109 18.7108H1.28906V18.3202H18.7109V18.7108Z" fill="black"/>
                        <path d="M4.59424 13.8152H5.53174C5.60425 13.8151 5.67378 13.7863 5.72505 13.7351C5.77632 13.6838 5.80514 13.6143 5.80518 13.5417V12.6042C5.80518 12.5317 5.77637 12.4622 5.72509 12.4109C5.67381 12.3596 5.60426 12.3308 5.53174 12.3308H4.59424C4.55833 12.3308 4.52276 12.3378 4.48957 12.3516C4.45639 12.3653 4.42624 12.3855 4.40084 12.4109C4.37545 12.4362 4.35531 12.4664 4.34157 12.4996C4.32784 12.5328 4.32078 12.5683 4.3208 12.6042V13.5417C4.3208 13.6143 4.34961 13.6838 4.40089 13.7351C4.45217 13.7864 4.52172 13.8152 4.59424 13.8152ZM4.86768 12.8777H5.2583V13.2683H4.86768V12.8777Z" fill="black"/>
                        <path d="M9.5791 15.679H10.5166C10.5891 15.679 10.6587 15.6501 10.71 15.5989C10.7612 15.5476 10.79 15.478 10.79 15.4055V14.468C10.79 14.3955 10.7612 14.326 10.7099 14.2747C10.6586 14.2234 10.5891 14.1946 10.5166 14.1946H9.5791C9.50658 14.1946 9.43703 14.2234 9.38575 14.2747C9.33447 14.3259 9.30566 14.3955 9.30566 14.468V15.4055C9.30564 15.4414 9.3127 15.477 9.32644 15.5102C9.34017 15.5434 9.36031 15.5735 9.38571 15.5989C9.4111 15.6243 9.44125 15.6444 9.47444 15.6582C9.50762 15.6719 9.54319 15.679 9.5791 15.679ZM9.85254 14.7415H10.2432V15.1321H9.85254V14.7415Z" fill="black"/>
                        <path d="M12.6411 15.679H13.5786C13.6145 15.679 13.6501 15.6719 13.6833 15.6582C13.7165 15.6444 13.7466 15.6243 13.772 15.5989C13.7974 15.5735 13.8175 15.5434 13.8313 15.5102C13.845 15.477 13.8521 15.4414 13.8521 15.4055V14.468C13.8521 14.3955 13.8232 14.3259 13.772 14.2747C13.7207 14.2234 13.6511 14.1946 13.5786 14.1946H12.6411C12.5686 14.1946 12.499 14.2234 12.4478 14.2747C12.3965 14.3259 12.3677 14.3955 12.3677 14.468V15.4055C12.3677 15.4414 12.3747 15.477 12.3884 15.5102C12.4022 15.5434 12.4223 15.5735 12.4477 15.5989C12.4731 15.6243 12.5033 15.6444 12.5364 15.6582C12.5696 15.6719 12.6052 15.679 12.6411 15.679ZM12.9146 14.7415H13.3052V15.1321H12.9146V14.7415Z" fill="black"/>
                        <path d="M15.7031 15.679H16.6406C16.6765 15.679 16.7121 15.6719 16.7453 15.6582C16.7785 15.6444 16.8086 15.6243 16.834 15.5989C16.8594 15.5735 16.8796 15.5434 16.8933 15.5102C16.907 15.477 16.9141 15.4414 16.9141 15.4055V14.468C16.9141 14.3955 16.8853 14.3259 16.834 14.2747C16.7827 14.2234 16.7131 14.1946 16.6406 14.1946H15.7031C15.6306 14.1946 15.5611 14.2234 15.5098 14.2747C15.4585 14.3259 15.4297 14.3955 15.4297 14.468V15.4055C15.4297 15.4414 15.4367 15.477 15.4505 15.5102C15.4642 15.5434 15.4843 15.5735 15.5097 15.5989C15.5351 15.6243 15.5653 15.6444 15.5985 15.6582C15.6316 15.6719 15.6672 15.679 15.7031 15.679ZM15.9766 14.7415H16.3672V15.1321H15.9766V14.7415Z" fill="black"/>
                        </svg>`;
                }
            },
            statusSwitch (status) {
                switch (status) {
                    case 'Not Submitted':
                        return 'status-grey';
                        break;
                    case 'In Process':
                        return 'status-yellow';
                        break;
                    case 'Approved':
                        return 'status-purple';
                        break;
                    case 'Issued':
                        return 'status-blue';
                        break;
                    case 'Completed':
                    case 'Adopted':                        
                        return 'status-green';
                        break;
                    case 'Denied':
                        return 'status-red';
                        break;
                    default:
                        return 'status-transparent';
                        break;
                }
            },
            openGallery () {
                setTimeout(this.$refs.carousel.computeCarouselWidth, 300)
            },
            singleMapSecond (val_lat, val_lng) {
                var fenway = {lat: parseFloat(val_lat), lng: parseFloat(val_lng)};
                var map = new google.maps.Map(document.getElementById('map2'), {
                    center: fenway,
                    zoom: 14,
                });
                var markerIcon = {
                    anchor: new google.maps.Point(22, 16),
                    url: '/images/marker.png',
                }
                var marker = new google.maps.Marker({
                    position: fenway,
                    map: map,
                    icon: markerIcon,
                });
            },
            singleMap(val_lat, val_lng) {
                var fenway = {lat: parseFloat(val_lat), lng: parseFloat(val_lng)};
                var map = new google.maps.Map(document.getElementById('map'), {
                    center: fenway,
                    zoom: 14,
                });
                var markerIcon = {
                    anchor: new google.maps.Point(22, 16),
                    url: '/images/marker.png',
                }
                var marker = new google.maps.Marker({
                    position: fenway,
                    map: map,
                    icon: markerIcon,
                });
            }
    	},
        watch: {
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    .note-wrapper {
        display: flex;
    }
    .type-note {
        width: 33.333%;
        padding: 15px;
    }
    .note-date {
        padding-bottom: 10px;
        font-weight: bold;
        text-align: left;
    }
    .note-item {
        background: #e7ecf6;
        padding: 25px;
        border-radius: 25px;
        height: 400px;
        overflow-y: scroll;
    }
    .note-item::-webkit-scrollbar {
        width: 8px;
    }
    .note-item::-webkit-scrollbar-track {
        background-color: transparent;
        border-radius: 100px;
    }
    .note-item::-webkit-scrollbar-thumb {
        background-color: #a6a6a6;
        border-radius: 100px;
    }
    .type-icons {
        flex-grow: 1;
    }
    .square-wrapper {
        width: 12.5%;
        text-align: center;
        padding-right: 5px;
    }
    .square-blue {
        background: #e7ecf6;
        padding-top: 20px;
        min-height: 100px;
        border-radius: 15px;
    }
    .square-blue strong {
        font-weight: bold;
    }
    .type-page .container {
        margin-left: 0;
    }
    .type-title {
        padding: 30px;
        background: #4a5f73;
        margin-left: -30px;
        margin-right: -30px;
        display: flex;
        flex-grow: 1;
        text-align: right;
        color: #fff;
    }
    .type-title h1 {
        color: #fff;
        text-align: left;
    }
    .type-container {
        width: calc( 100% - 400px );
        padding-left: 30px;
        padding-right: 30px;
    }
    .side-menu-bottom {
        position: fixed;
        bottom: 0;
    }
    .side-menu-bottom-item {
        color: #fff;
        font-size: 1.4rem;
        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 50px;
        cursor: pointer;
    }
    .side-menu-item.active {
        background: #4a5f73;
    }
    .side-menu-item {
        font-size: 1.4rem;
        text-align: left;
        font-weight: bold;
        width: 100%;
        padding-top: 15px;
        padding-bottom: 15px;
        padding-left: 25px;
        cursor: pointer;
    }
    .logo-img {
        width: 100%;
        padding: 30px 15px;
    }
    .left-side-bar {
        background: #13293e;
    }
    .side-menu-wrapper {
        color: #fff;
    }
    section {
        padding-left: 0;
        padding-right: 0;
    }
    .st-symbol {
        display: inline-block;
        position: absolute;
        font-size: 2rem;
        line-height: 0;
        margin-top: 13px;
        margin-left: 15px;
    }
    .st-label {
        margin-left: 50px;
    }
    .mt-auto {
        margin-top: auto;
    }
    .view-button {
        font-weight: bold;
        margin-right: 5px;
    }
    .edit-button {
        font-weight: bold;
        display: block;
        margin-top: 30px;
    }
    .back-label {
        padding: 0;
    }
    .btn-header {
        font-size: 11px;
        padding: 10px;
    }
    .upload-spinner {
        width: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9;
    }
    .row-grey {
        background-color: rgba(0,0,0,.03);
    }
    .row-green {
        background: #68CA72;
    }
    .row-red {
        background: #ff1953;
    }
    .row-blue {
        background: #79B8F2;
    }
    .row-orange {
        background: #FF9357;
    }
    .flex-center {
        align-self: center;
    }
    h1 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 3rem;
        text-transform: uppercase;
    }
    h2 {
        font-family: Poppins;
        font-weight: 600;
        font-size: 1.5rem;
        text-decoration: underline;
        cursor: pointer;
    }
    .function_icons {
        width: 30px;
        margin-right: 10px;
        cursor: pointer;
        margin-top: 12px;
    }
    html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td {
        font-family: Poppins;
    }
    .tab-logo {
        position: absolute;
        top: 0;
        right: 0;
        width: 100px;
    }
    .tab-row {
        position: relative;
    }
    .overview-val {
        font-weight: 500;
    }
    .btn-primary-reverse {
        color: #fff;
        font-weight: 600;
        background: #13293E;
        border-radius: 30px;
    }
    h3 {
        font-weight: 600;
        font-size: 1.5rem;
    }
    .pic-media-wrapper {
        padding-left: 10px;
        padding-right: 10px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .pic-media {
        width: 100%;
    }
    .modal-close {
        color: #fff;
        top: 10px;
        right: 10px;
        position: absolute;
        opacity: 1;
    }
    .plan-table {
        color: #000;
    }
    .plan-table th {
        font-size: 1.2rem;
        font-weight: 500;
    }
    .plan-table td {
        font-size: 1.2rem;
        font-weight: 300;
    }
    .floor-plan-block {
        font-weight: 400;
    }
    .status-cell {
        font-weight: 700;
    }
    .status-col {
        /* border-left: 2px solid #545454; */
    }
    .planning-table-cell td:nth-child(2){
        border-left: 2px solid #545454;
        border-right: 2px solid #545454;
    }
    .table-header-text {
        text-decoration: none;
        font-size: 2.3rem;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .fp-img {
        background: #13293E;
        padding: 20px;
        margin: 30px;
    }
    .plan-table td {
        padding-top: 0;
    }
    .site-plan-bg {
        padding: 30px;
    }
    .site-plan-bg a {
        display: inline-block;
        padding: 20px;
        background: #13293E;
        
    }
    @media (max-width: 991px) {
        .row {
            overflow-x: scroll;
        }
        .fp-img {
            margin: 5px;
        }
        .col-xs-4 {
            padding-left: 5px;
            padding-right: 5px;
        }
    }
    @media print {
        .table th {
            background-color: #12283FE5 !important;
        }
        .table .fa {
            display: none;
        }
    }
</style>
<style>
    .type-image .nav-tabs {
        border-top: 2px solid #BBB;
        border-bottom: 2px solid #BBB !important;
    }
    .type-image .nav-tabs .nav-item .nav-link {
        text-decoration: none;
        padding-top: 20px;
    }
    .type-page .single-project-detail .tab-row > div > div > .nav-tabs {
        display: none;
    }
    td p {
        color: #000;
        font-size: 1rem;
        font-weight: 500;
    }
    .nav-link {
        padding: 20px;
    }
    .nav.nav-tabs.type-nav-general {
        border-bottom: 2px solid #545454;
    }
    .type-nav-general {
        margin-top: 20px;
    }
    .type-nav-general .nav-item .nav-link {
        font-weight: 600;
        text-decoration: underline;
        color: #000000;
    }
    .type-nav-general .nav-item .nav-link.active {
        background: #C4C4C4;
    }
    .type-nav-general .nav-item {
        margin: 0;
    }
    .modal-header {
        background: #13293E;
        color: #fff;
        font-family: Poppins;
        font-weight: 600;
        font-size: 1.7rem;
        text-transform: uppercase;
        padding: 50px;
    }
    .logo-modal {
        width: 300px;
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .modal-address {
        font-size: 1.4rem;
        font-weight: 300;
        font-family: Poppins;
    }
    .modal-table td {
        font-size: 1.2rem;
    }
    .modal-body {
        padding: 3rem;
    }
    @media only screen and  (max-width: 768px) {
        .logo-modal {
            display: none;
        }
    }
    @media (max-width: 991px) {
        .modal-body {
            padding: 10px;
        }
    }
</style>